import React, { useEffect, useRef, useState, useMemo } from "react";
import AdminHeaderNew from "../NewAdminPanel/Common/AdminHeader";
import AdminSideBarNew from "../NewAdminPanel/Common/AdminSideBar";
import AdminFooterNew from "../NewAdminPanel/Common/AdminFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { kml } from "@tmcw/togeojson";

import {
  faExclamation,
  faUsers,
  faListCheck,
  faArrowRight,
  faSeedling,
  faClipboardList,
  faOilCan,
  faBinoculars,
  faLeaf,
  faIndustry,
} from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import Circles from "../../assets/images/circle.png";
import axios from "axios";
import { use } from "react";
import blockedData from "../../config/blockedSchemes.json";
// Export constant loaded from JSON
export const BLOCKED_SCHEMES = blockedData.BLOCKED_SCHEMES;

const Dashboard = () => {
    //const [BLOCKED_SCHEMES, setBlockedSchemes] = useState([]);
    //useEffect(() => {
    //    // file path relative to public/
    //    fetch(`${process.env.PUBLIC_URL}/blockedSchemes.json`)
    //        .then((res) => res.json())
    //        .then((data) => {
    //            // expect { BLOCKED_SCHEMES: [...] }
    //            if (data && Array.isArray(data.BLOCKED_SCHEMES)) {
    //                setBlockedSchemes(data.BLOCKED_SCHEMES);
    //            }
    //        })
    //        .catch((err) => {
    //            console.error("Failed to load blockedSchemes.json", err);
    //            setBlockedSchemes([]); // fallback
    //        });
    //}, []);
    // Read storage once
    const schemeGlobal = sessionStorage.getItem("schemeCodeModel");

    // Use global variable
    const isSchemeBlocked = BLOCKED_SCHEMES.includes(schemeGlobal);
  const [userCount, setUserCount] = useState(0);
  const [surveyCountNew, setSurveyCountNew] = useState(0);
  const [surveyPlotCountNew, setSurveyPlotCountNew] = useState(0);
  const [seedDemonstrationNew, setSeedDemonstrationNew] = useState(0);
  const [surveySeedDistricbution, setSurveySeedDistricbution] = useState(0);
  const [surveyRKVYAPI, setSurveyRKVYAPI] = useState(0);
  const [nmeoopCount, setNmeoopCount] = useState(0);
  const [kEcultivationCount, setKEcultivationCount] = useState(0);
  const [patanjaliCount, setPatanjaliCount] = useState(0);
  const [nMEO3FCount, setNMEO3FCount] = useState(0);
  const [latestSurveyCount, setLatestSurveyCount] = useState([]);
  const [stateAPISurveyRows, setStateAPISurveyRows] = useState([]);
  const [latestUserCount, setLatestUserCount] = useState([]);
  const [summaryCountLoading, setSummaryCountLoading] = useState(true);
  const [latestSurveyLoading, setLatestSurveyLoading] = useState(true);
  const [stateApiCountLoading, setStateApiCountLoading] = useState(true);
  const [rkvyCountLoading, setRkvyCountLoading] = useState(true);
  const [pdmcCountLoading, setPdmcCountLoading] = useState(true);
  const [activeUserCountLoading, setActiveUserCountLoading] = useState(true);
  const [userCountNew, setUserCountNew] = useState(0);
  const [farmerCount, setFarmerCount] = useState(0);
  const [LoaderFarmer, setLoaderFarmer] = useState(false);
  const [userVisible, setUserVisible] = useState(false);
  const [surveyVisible, setSurveyVisible] = useState(false);
  const [stateAPISurveyVisible, setStateAPISurveyVisible] = useState(false);
  const [seedDemoVisible, setseedDemoVisible] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [expandedRowIndexs, setExpandedRowIndexs] = useState(null);
  const [expandedRowData, setExpandedRowData] = useState([]); // holds fetched data per row
  const [expandedRowDatas, setExpandedRowDatas] = useState([]); // holds fetched data per row
  const [showAll, setShowAll] = useState(false); // state to toggle view
  const [showAllSurveyRows, setShowAllSurveyRows] = useState(false);
  const [seedVisible, setSeedVisible] = useState(false);
  const [polygonVisible, setPolygonVisible] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(true);
  const [nmeoopData, setNmeoopData] = useState([]);
  const [kEcultivationData, setKEcultivationData] = useState([]);
  const [nmeo3fData, setNmeo3fData] = useState([]);
  const [showAgencyCounts, setShowAgencyCounts] = useState(false);
  const [latestPolygonCount, setLatestPolygonCount] = useState([]);
  const [latestSeedCount, setLatestSeedCount] = useState([]);
  const [selectedFinYear, setSelectedFinYear] = useState("All");
  const [rkvyVisible, setRkvyVisible] = useState(false);
  const [latestRkvyCount, setLatestRkvyCount] = useState([]);
  const [rkvyCount, setRkvyCount] = useState(0);
  const [showAllRkvyRows, setShowAllRkvyRows] = useState(false);
  const [expandedRkvyRowIndex, setExpandedRkvyRowIndex] = useState(null);
  const [expandedRkvyRowData, setExpandedRkvyRowData] = useState([]);
  const [isLoadingExpandedData, setIsLoadingExpandedData] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [seedDemoLoading, setSeedDemoLoading] = useState(false);
  const [seedDemoLoadingDots, setSeedDemoLoadingDots] = useState(0);
  const seedDemoIntervalRef = useRef(null);
  const seedDemoTimeoutRef = useRef(null);
  const [seedDemoDropDown, setSeedDemoDropDown] = useState([]);
  const [showAllSeedDemoRows, setShowAllSeedDemoRows] = useState(false);
  const [seedDemoTable, setSeedDemoTable] = useState([]);
  const [seedDemoCount, setDemoCount] = useState(0);
  const [assetsLoading, setAssetsLoading] = useState(false);
  const [assetsVisible, setAssetsVisible] = useState(false);
  const [assetsTable, setAssetsTable] = useState([]);
  const [selectedAssetsOption, setSelectedAssetsOption] = useState("ALL");
  const [assetsCount, setAssetsCount] = useState(0);
  const [showAllAssetRows, setShowAllAssetRows] = useState(false);
  const [VillageName, setVillageName] = useState("");
  const [finYears, setFinYears] = useState(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const fyStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
    const years = ["All"];

    // Add last 5 financial years based on April-April cycle
    for (let i = 0; i < 5; i++) {
      const startYear = fyStartYear - i;
      const endYear = startYear + 1;
      years.push(`${startYear}-${endYear}`);
    }

    return years;
  });

  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  const [cropGroups, setCropGroups] = useState([]);
  


  const [retrievedArray, setRetrievedArray] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(() =>
    String(sessionStorage.getItem("districtCodeModel") || "")
  );

  const [retrievedArraySubDistrict, setRetrievedArraySubDistrict] = useState(
    []
  );
  const [selectedSubDistrict, setSelectedSubDistrict] = useState(() =>
    String(sessionStorage.getItem("subDistrictCodeModel") || "")
  );

    const [selectedBlock, setSelectedBlock] = useState(() =>
        String(sessionStorage.getItem("blockCode") || "")
    );
    const [stateAPIsurveyCount,setstateAPIsurveyCount] = useState(0);
    const [stateAPISeprateSurveyCount, setStateAPISeprateSurveyCount] = useState(0);
    const [stateAPISeprateSurveyCounts, setStateAPISeprateSurveyCounts] = useState(0);
    
    const [pdmcAPICount, setPDMCAPICount] = useState(0);
    const [pdmcVisible, setPdmcVisible] = useState(false);
    const [latestPdmcCount, setLatestPdmcCount] = useState([]);
    const [showAllPdmcRows, setShowAllPdmcRows] = useState(false);
    const [expandedPdmcRowIndex, setExpandedPdmcRowIndex] = useState(null);
    const [expandedPdmcRowData, setExpandedPdmcRowData] = useState([]);
    
    const [showAllVillages, setShowAllVillages] = useState(false);
    const [selectedSeason, setSelectedSeason] = useState(0);
    const[selectedCropGroup, setSelectedCropGroup] = useState(0);
    const [seasons, setSeasons] = useState([]);
    const [dashboardFiltersReady, setDashboardFiltersReady] = useState(
      schemeCode !== "5"
    );
    const isFirstSeasonEffect = useRef(true);
    
    const villageList = VillageName
      ? VillageName.split(",").map(v => v.trim()).filter(Boolean)
      : [];
    
      const visibleVillages = showAllVillages
      ? villageList
      : villageList.slice(0, 39);



  useEffect(() => {
    try {
       const villageName = sessionStorage.getItem("villageName");
       setVillageName(villageName);
       //console.log('villageName: ', villageName);
      const raw = sessionStorage.getItem("districtArray");
      const parsed = raw ? JSON.parse(raw) : [];
      const sorted = Array.isArray(parsed)
        ? [...parsed].sort((a, b) =>
            String(a.name || "").localeCompare(
              String(b.name || ""),
              undefined,
              { sensitivity: "base" }
            )
          )
        : [];
      setRetrievedArray(sorted);
    } catch (err) {
      console.warn("Invalid districtArray in sessionStorage:", err);
      setRetrievedArray([]);
    }
  }, []);

  useEffect(() => {
    if (!Array.isArray(retrievedArray) || retrievedArray.length === 0) return;

    const fromStorage = String(
      sessionStorage.getItem("districtCodeModel") || ""
    );
    const existsInList = (code) =>
      retrievedArray.some((d) => String(d.code) === String(code));

    if (fromStorage && existsInList(fromStorage)) {
      if (String(selectedDistrict) !== String(fromStorage)) {
        setSelectedDistrict(fromStorage);
      }
      return;
    }
    if (selectedDistrict && !existsInList(selectedDistrict)) {
      setSelectedDistrict("");
    }
  }, [retrievedArray]);

  useEffect(() => {
    try {
      
      const raw = sessionStorage.getItem("districtArray");
      const parsed = raw ? JSON.parse(raw) : [];
      const sorted = Array.isArray(parsed)
        ? [...parsed].sort((a, b) =>
            String(a.name || "").localeCompare(
              String(b.name || ""),
              undefined,
              { sensitivity: "base" }
            )
          )
        : [];
      setRetrievedArraySubDistrict(sorted);
    } catch (err) {
      console.warn("Invalid districtArray in sessionStorage:", err);
      setRetrievedArraySubDistrict([]);
    }
  }, []);

  useEffect(() => {
    if (
      !Array.isArray(retrievedArraySubDistrict) ||
      retrievedArraySubDistrict.length === 0
    )
      return;

    const fromStorage = String(
      sessionStorage.getItem("subDistrictCodeModel") || ""
    );
    const existsInList = (code) =>
      retrievedArraySubDistrict.some((d) => String(d.code) === String(code));

    if (fromStorage && existsInList(fromStorage)) {
      if (String(selectedSubDistrict) !== String(fromStorage)) {
        setSelectedDistrict(fromStorage);
      }
      return;
    }
    if (selectedSubDistrict && !existsInList(selectedSubDistrict)) {
      setSelectedSubDistrict("");
    }
  }, [retrievedArraySubDistrict]);

  const handleDistrictChange = (e) => {
    const value = String(e.target.value || "");
    const label = e.target.options[e.target.selectedIndex]?.text || "";

    setSelectedDistrict(value);
    if (sessionStorage.getItem("userTypeCodeModel") === "3") {
      sessionStorage.setItem("districtCodeModel", value);
      sessionStorage.setItem("districtNameModel", label);
    } else if (sessionStorage.getItem("userTypeCodeModel") === "4") {
      sessionStorage.setItem("subDistrictCodeModel", value);
      sessionStorage.setItem("subDistrictNameModel", label);
    }
  };

    const handleSubDistrictChange = (e) => {
        
    const value = String(e.target.value || "");
        const label = e.target.options[e.target.selectedIndex]?.text || "";
        
    setSelectedSubDistrict(value);
        if (sessionStorage.getItem("userTypeCodeModel") === "3") {
            
      sessionStorage.setItem("districtCodeModel", value);
      sessionStorage.setItem("districtNameModel", label);
        } else if (sessionStorage.getItem("userTypeCodeModel") === "4") {
           
      sessionStorage.setItem("subDistrictCodeModel", value);
      sessionStorage.setItem("subDistrictNameModel", label);
    }
  };

    const handleBlockChange = (e) => {
        console.log('handleBlockChange changed');
        
        const value = String(e.target.value || "");
        const label = e.target.options[e.target.selectedIndex]?.text || "";
        
        setSelectedBlock(value);
        //setSelectedSubDistrict(value);
        if (sessionStorage.getItem("userTypeCodeModel") === "4") {
           
             sessionStorage.setItem("blockCode", value);
             sessionStorage.setItem("blockName", label);
        }
    };



   const validSchemeCodesForSeedDemonstration = ["20", "15", "9", "8", "5","46","48"];
   //const validSchemeCodesForAssetsCard = ["5"]; 
      //const validSchemeCodesForSeedDemonstration = [];
  const validSchemeCodesForAssetsCard = ["5", "14"]; 

  const assetOptions = useMemo(
    () => [
       { typeId: "ALL", typeName: "All" },
      { typeId: "oilMils", typeName: "Oil Mills" },
      { typeId: "flexiFund", typeName: "Flexi Fund" },
      { typeId: "seedHubs", typeName: "Seed Hubs" },
      { typeId: "seedStorage", typeName: "Seed Storage" },
    ],
    []
  );
 
  const selectedAsset = assetOptions.find(option => option.typeId === selectedAssetsOption);
  const assetsDummySource = useMemo(
    () => [
      {
        id: 1,
        stateCode: "28",
        stateName: "Andhra Pradesh",
        districtCode: "521",
        districtName: "Anantapur",
        subDistrictCode: "52101",
        subDistrictName: "Hindupur",
        assetCategory: "oilMils",
        totalAssets: 48,
        assetsInUse: 41,
        assetsUnderMaintenance: 4,
        assetsIdle: 3,
      },
      {
        id: 2,
        stateCode: "10",
        stateName: "Bihar",
        districtCode: "219",
        districtName: "Patna",
        subDistrictCode: "21907",
        subDistrictName: "Barh",
        assetCategory: "oilMils",
        totalAssets: 32,
        assetsInUse: 26,
        assetsUnderMaintenance: 3,
        assetsIdle: 3,
      },
      {
        id: 3,
        stateCode: "24",
        stateName: "Gujarat",
        districtCode: "301",
        districtName: "Rajkot",
        subDistrictCode: "30113",
        subDistrictName: "Dhoraji",
        assetCategory: "flexiFund",
        totalAssets: 21,
        assetsInUse: 18,
        assetsUnderMaintenance: 2,
        assetsIdle: 1,
      },
      {
        id: 4,
        stateCode: "29",
        stateName: "Karnataka",
        districtCode: "495",
        districtName: "Belagavi",
        subDistrictCode: "49509",
        subDistrictName: "Gokak",
        assetCategory: "seedStorage",
        totalAssets: 17,
        assetsInUse: 14,
        assetsUnderMaintenance: 2,
        assetsIdle: 1,
      },
      {
        id: 5,
        stateCode: "27",
        stateName: "Maharashtra",
        districtCode: "516",
        districtName: "Nashik",
        subDistrictCode: "51604",
        subDistrictName: "Dindori",
        assetCategory: "seedStorage",
        totalAssets: 55,
        assetsInUse: 49,
        assetsUnderMaintenance: 3,
        assetsIdle: 3,
      },
      {
        id: 6,
        stateCode: "03",
        stateName: "Punjab",
        districtCode: "145",
        districtName: "Ludhiana",
        subDistrictCode: "14521",
        subDistrictName: "Jagraon",
        assetCategory: "seedHubs",
        totalAssets: 28,
        assetsInUse: 24,
        assetsUnderMaintenance: 2,
        assetsIdle: 2,
      },
    ],
    []
  );

  

async function fetchStateAPISeprateSurveyCount() {
  let roleCode = sessionStorage.getItem("userTypeCodeModel");
  if (roleCode === "6") {
    roleCode = "3";
  }
  const roleCodeInt = parseInt(roleCode, 10);

  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
  const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
  const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;
  const userCode = sessionStorage.getItem("userCodeModel") || 0;

  const parm = {
    schemeCode,
    stateCode: roleCodeInt >= 2 ? stateCode : 0 ,
    districtCode:
      roleCodeInt >= 3
        ? districtCode === "null" ? 0 : parseInt(districtCode, 10)
        : 0,
    subDistrictCode:
      roleCodeInt >= 4
        ? subDistrictCode === "null" ? 0 : parseInt(subDistrictCode, 10)
        : 0,
    userLevel: roleCodeInt,
    str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    userCode,
  };

  setStateApiCountLoading(true);
  try {
    const { data } = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/SurveyCountGroupWise/SurveysCountGroupWiseExtApi`,
      parm
    );

    const rows = Array.isArray(data?.dataContent) ? data.dataContent : [];
    setStateAPISurveyRows(rows);               // NEW

    const totalSurvey = rows.reduce(
      (sum, row) => sum + (Number(row?.totalSurvey) || 0),
      0
    );
    setStateAPISeprateSurveyCount(totalSurvey);
    setStateAPISeprateSurveyCounts(totalSurvey);
  } catch (error) {
    console.error("Error fetching separate State API survey count:", error);
    setStateAPISeprateSurveyCount(0);
    setStateAPISurveyRows([]);                 // NEW
  } finally {
    setStateApiCountLoading(false);
  }
}

  const AgencyCard = ({ title, count, icon, exportData, fileName }) => (
    <div className="col-md-3 col-sm-6">
      <div
        className="card rounded-4 p-3 bg-white textname cardsize"
        style={{
          minHeight: "100px",
          transition: "all 0.3s ease",
          boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
          border: "1px solid #e0e0e0",
          cursor: "default",
        }}
      >
        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-center">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle mb-3"
            style={{
              width: "30px",
              height: "30px",
              backgroundColor: "#f1f1f1",
              color: "#333",
            }}
          >
            <FontAwesomeIcon icon={icon} size="lg" />
          </div>
          <h6 className="cardsize-text" style={{ fontSize: "0.95rem" }}>
            {title}
          </h6>
          <h4 className="sizecount">{count}</h4>
          {exportData && (
            <div className="mt-1">
              <button
                className="btn btn-sm btn-outline-dark d-flex align-items-center gap-2"
                onClick={() => exportToCSVs(exportData, fileName)}
                title={`Export ${title} Data`}
              >
                <i className="bi bi-file-earmark-arrow-down-fill fs-6"></i>
                <span>Export CSV</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  // const renderCardCount = (isLoading, value) => {
  //   if (isLoading) {
  //     return (
  //       <span className="spinner-border spinner-border-sm text-white" role="status">
  //         <span className="visually-hidden">Loading...</span>
  //       </span>
  //     );
  //   }
  //   return value ?? 0;
  // };

  const renderCardCount = (isLoading, value) => {
   
    if (isLoading) {
      return (
        <div className="spinner-border text-light" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      );
    }
    return value ?? 0;
  };
  const exportToCSVs = (data, filename) => {
    const csvRows = [];

    // Set custom headers including S.No
    const headers = [
      "S.No",
      "State Name",
      "Registered Farmer Counts",
      "Land Capture",
    ];
    csvRows.push(headers.join(","));

    // Group data by state to calculate counts per state
    const stateGroups = {};

    data.forEach((item) => {
      // Handle different state name fields based on data type
      let stateName;
      if (filename === "KE_Cultivation_Data") {
        stateName = item.farmer_State_Name || "Unknown State";
      } else {
        stateName = item.stateName || "Unknown State";
      }

      if (!stateGroups[stateName]) {
        stateGroups[stateName] = {
          farmerCount: 0,
          landCapture: 0,
        };
      }

      stateGroups[stateName].farmerCount += 1;

      // Calculate land capture based on data type
      let landArea = 0;
      if (filename === "KE_Cultivation_Data") {
        // For KE Cultivation data, use specific field
        landArea =
          parseFloat(item.total_Area_Plot_Under_Oil_Palm_Cultivation) || 0;
      } else if (filename === "NMEO_3F_Prospective") {
        // For NMEO 3F Prospective data, use farmerLandDetailsModel

        if (
          item.farmerLandDetailsModel &&
          Array.isArray(item.farmerLandDetailsModel)
        ) {
          landArea = item.farmerLandDetailsModel.reduce((sum, land) => {
            //console.log("Processing land detail:", land);
            // Check different possible field names for land area
            const landAreaValue =
              land.totalArea ||
              land.landArea ||
              land.plotArea ||
              land.area ||
              land.plotTotalArea ||
              land.landAreaInHectare ||
              land.areaInHectare ||
              land.cultivatedArea ||
              land.irrigatedArea ||
              0;
            //console.log("Land area value found:", landAreaValue);
            return sum + (parseFloat(landAreaValue) || 0);
          }, 0);
        } else if (
          item.farmerLandDetailsModel &&
          typeof item.farmerLandDetailsModel === "object"
        ) {
          //console.log("Processing single farmerLandDetailsModel object");
          // Handle if farmerLandDetailsModel is a single object instead of array
          const landAreaValue =
            item.farmerLandDetailsModel.totalArea ||
            item.farmerLandDetailsModel.landArea ||
            item.farmerLandDetailsModel.plotArea ||
            item.farmerLandDetailsModel.area ||
            item.farmerLandDetailsModel.plotTotalArea ||
            item.farmerLandDetailsModel.landAreaInHectare ||
            item.farmerLandDetailsModel.areaInHectare ||
            item.farmerLandDetailsModel.cultivatedArea ||
            item.farmerLandDetailsModel.irrigatedArea ||
            0;
          //console.log("Single object land area value:", landAreaValue);
          landArea = parseFloat(landAreaValue) || 0;
        } else {
          //console.log("No farmerLandDetailsModel found or invalid structure");
          // Fallback: check if land area is directly on the item
          landArea = parseFloat(
            item.totalArea || item.landArea || item.plotArea || item.area || 0
          );
         // console.log("Fallback land area:", landArea);
        }
        //console.log("Final calculated land area for item:", landArea);
      } else if (
        item.farmerPlotRegistrationList &&
        Array.isArray(item.farmerPlotRegistrationList)
      ) {
        landArea = item.farmerPlotRegistrationList.reduce((sum, plot) => {
          // Check different possible field names for plot area
          const plotArea =
            plot.plotTotalArea ||
            plot.totalArea ||
            plot.landArea ||
            plot.plotArea ||
            0;
          return sum + (parseFloat(plotArea) || 0);
        }, 0);
      } else if (
        item.farmerCropSurveyPolygonList &&
        Array.isArray(item.farmerCropSurveyPolygonList)
      ) {
        // Fallback to original field if farmerPlotRegistrationList is not available
        landArea = item.farmerCropSurveyPolygonList.reduce((sum, polygon) => {
          return sum + (parseFloat(polygon.plotTotalArea) || 0);
        }, 0);
      } else if (item.totalArea) {
        landArea = parseFloat(item.totalArea) || 0;
      } else if (item.landArea) {
        landArea = parseFloat(item.landArea) || 0;
      }

      stateGroups[stateName].landCapture += landArea;
    });

    // Add rows for each state with serial numbers
    let serialNumber = 1;
    Object.entries(stateGroups).forEach(([stateName, data]) => {
      const row = [
        serialNumber,
        `"${stateName}"`,
        data.farmerCount,
        data.landCapture.toFixed(2),
      ];
      csvRows.push(row.join(","));
      serialNumber++;
    });

    // Create CSV blob
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    // Download link
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (!dashboardFiltersReady) return;

    // alert(sessionStorage.getItem("userTypeCodeModel"));
    // alert(sessionStorage.getItem("stateCodeModel"));
    if (sessionStorage.getItem("userTypeCodeModel") !== "5") {
      fetchDataUser();
    }
    sessionStorage.removeItem("searchResults");
    sessionStorage.removeItem("searchFilters");
    totalRecoredCount();
    surveysCountGroupWise();
    userCountGroupWise();
    handleAddDataNMEOOP();
    if (sessionStorage.getItem("schemeCodeModel") === "15") {
      fetchRKVYData();
    
    }
if (sessionStorage.getItem("schemeCodeModel") === "1") {
    fetchPDMCData();
  }
     const scheme = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel");
    if (validSchemeCodesForSeedDemonstration.includes(scheme)){
      // handleSeedDemoOptionChange use karo taaki card count (seedDemonstrationNew) bhi update ho
      handleSeedDemoOptionChange(selectedOption || 1);
    }

    if (
      (scheme === "14" && stateCode === "36" || stateCode === "29") ||
      (scheme === "5" && stateCode === "34") ||
      (scheme === "6" && stateCode === "28")||
      (scheme === "22" && stateCode === "3") ||
      (scheme === "15" && stateCode === "29") ||
      (scheme === "8" && stateCode === "23") 
    ) {
      fetchStateAPISeprateSurveyCount();
    }

  }, [
    dashboardFiltersReady,
    selectedFinYear,
    selectedSeason,
    selectedBlock,
    selectedCropGroup,
  ]);

  useEffect(() => {
  fetchSeedDemoDropdown();
}, []);

  // Close all open tables/cards when filters change to avoid stale data
  useEffect(() => {
    setUserVisible(false);
    setSurveyVisible(false);
    setStateAPISurveyVisible(false);
    setSeedVisible(false);
    setPolygonVisible(false);
    setRkvyVisible(false);
    setseedDemoVisible(false);
    setAssetsVisible(false);
    setPdmcVisible(false);
    setShowAll(false);
    setShowAllSurveyRows(false);
    setLatestSurveyCount([]);
    setShowAllRkvyRows(false);
    setShowAllSeedDemoRows(false);
    setShowAllAssetRows(false);
    setShowAllPdmcRows(false);
    setExpandedRowIndex(null);
    setExpandedRowIndexs(null);
    setExpandedRowData([]);
    setExpandedRowDatas([]);
    setExpandedPdmcRowIndex(null);
    setExpandedPdmcRowData([]);
    setExpandedRkvyRowIndex(null);
    setExpandedRkvyRowData([]);
    setIsLoadingExpandedData(false);
  }, [selectedFinYear, selectedSeason,selectedCropGroup]);

  // Start loader by default so the card doesn't show 0
  useEffect(() => {
    const scheme = sessionStorage.getItem("schemeCodeModel");
    if (validSchemeCodesForSeedDemonstration.includes(scheme)) {
      setSeedDemoLoading(true);
      setSeedDemonstrationNew(null);
    }
  }, []);


    // Auto-select default Seed Demonstration option (prefer typeId === 1 for SD) and load count
  useEffect(() => {
    if (seedDemoDropDown && seedDemoDropDown.length > 0 && selectedOption === null) {
      const defaultItem =
        seedDemoDropDown.find((item) => Number(item.typeId) === 1) || seedDemoDropDown[0];
      if (defaultItem && defaultItem.typeId !== undefined) {
        handleSeedDemoOptionChange(defaultItem.typeId);
      }
    }
  }, [seedDemoDropDown]);
  

  useEffect(() => {
    const scheme = sessionStorage.getItem("schemeCodeModel");

    if (!validSchemeCodesForAssetsCard.includes(scheme)) {
      setAssetsTable([]);
      setAssetsCount(0);
      setAssetsVisible(false);
      setAssetsLoading(false);
      return;
    }

    const fetchAssetsData = async () => {
      setAssetsLoading(true);

      try {
        let finalCount = 0;

        // For scheme 5 and 14, always use live API (no dummy data)
        if (scheme === "5" || scheme === "14") {
          const userType = sessionStorage.getItem("userTypeCodeModel");
          const stateCodeSess = sessionStorage.getItem("stateCodeModel");
          const districtCodeSess = sessionStorage.getItem("districtCodeModel");

          const baseUrl =
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE;

          const url =
            scheme === "5"
              ? `${baseUrl}/api/Asset/GetAssetCountDashboard`
              : `${baseUrl}/api/AssetOP/GetAssetCountDashboard`;

          // Build payload based on login level
          const payload = {
            schemeCode: Number(scheme),
          };

          // State login – add stateCode
          if (userType === "2" && stateCodeSess) {
            payload.stateCode = Number(stateCodeSess);
          }

          // District login – add both stateCode and districtCode
          if (userType === "3") {
            if (stateCodeSess) {
              payload.stateCode = Number(stateCodeSess);
            }
            if (districtCodeSess) {
              payload.districtCode = Number(districtCodeSess);
            }
          }

          const { data } = await axios.post(
            url,
            payload,
            {
              headers: {
                accept: "*/*",
                "Content-Type": "application/json",
              },
            }
          );

          const apiContent = data?.dataContent?.[0] ?? data?.dataContent ?? null;
          const apiDetails = apiContent?.assetDetails ?? [];

          // If API returned rows, show them; otherwise keep table empty
          if (Array.isArray(apiDetails) && apiDetails.length > 0) {
            setAssetsTable(apiDetails);
          } else {
            setAssetsTable([]);
          }

          const apiCount =
            apiContent?.assetCount?.totalAssetsAdded ??
            data?.dataContent?.assetCount?.totalAssetsAdded ??
            data?.totalAssetsAdded ??
            0;

          finalCount = Number.isFinite(apiCount) ? apiCount : 0;
        } else {
          // Other schemes: keep existing dummy behaviour
          const filteredData =
            selectedAssetsOption === "ALL"
              ? assetsDummySource
              : assetsDummySource.filter(
                  (item) => item.assetCategory === selectedAssetsOption
                );

          setAssetsTable(filteredData);

          finalCount = filteredData.reduce(
            (sum, item) => sum + (item.totalAssets || 0),
            0
          );
        }

        setAssetsCount(finalCount);
      } catch (error) {
        console.error("Error fetching assets count:", error);
        // In case of error, keep previous count/dummy fallback
      } finally {
        setAssetsLoading(false);
      }
    };

    fetchAssetsData();
  }, [selectedAssetsOption, assetsDummySource]);

   // Cleanup any running intervals/timeouts on unmount
  useEffect(() => {
    return () => {
      if (seedDemoIntervalRef.current) {
        clearInterval(seedDemoIntervalRef.current);
        seedDemoIntervalRef.current = null;
      }
      if (seedDemoTimeoutRef.current) {
        clearTimeout(seedDemoTimeoutRef.current);
        seedDemoTimeoutRef.current = null;
      }
    };
  }, []);
  // Seasons dropdown (for schemeCode 5)
  useEffect(() => {
    const fetchSeasons = async () => {
      try {
        const baseUrl =
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;
        const res = await axios.get(`${baseUrl}/api/seasons`);

        const list = res?.data?.dataContent || [];
        setSeasons(list);
      } catch (err) {
        console.error("Error fetching seasons:", err);
      }
    };
    ["5", "48"].includes(schemeCode) && fetchSeasons();
   // schemeCode === "5" && fetchSeasons();
  }, [schemeCode]);

  // Crop Group dropdown (for schemeCode 5) using FarmerDetailsforDashboard
  useEffect(() => {
    const fetchCropGroups = async () => {
      try {
        const baseUrl =
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE;
        const toSafeInt = (value) => {
          const raw = String(value ?? "").trim().toLowerCase();
          if (!raw || raw === "null" || raw === "undefined") return 0;
          if (!/^\d+$/.test(raw)) return 0;
          const parsed = Number(raw);
          return Number.isNaN(parsed) ? 0 : parsed;
        };

        const safeStateCode = toSafeInt(sessionStorage.getItem("stateCodeModel"));
        const safeDistrictCode = toSafeInt(
          sessionStorage.getItem("districtCodeModel")
        );
        const safeSubDistrictCode = toSafeInt(
          sessionStorage.getItem("subDistrictCodeModel")
        );
        const safeVillageCode = toSafeInt(
          sessionStorage.getItem("villageCodeModel")
        );

        // Keep storage clean so future payloads don't send "null"/"null1".
        sessionStorage.setItem("stateCodeModel", String(safeStateCode));
        sessionStorage.setItem("districtCodeModel", String(safeDistrictCode));
        sessionStorage.setItem("subDistrictCodeModel", String(safeSubDistrictCode));
        sessionStorage.setItem("villageCodeModel", String(safeVillageCode));

        const payload = {
          //SchemeCode: "5"
           SchemeCode: schemeCode,
        };

        const res = await axios.post(
          `${baseUrl}/api/Management/CommCropGroup/getCropGroupExtList`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const list = res?.data?.dataContent || [];
        // Build unique crop groups in O(n) for large "All" responses.
        const uniqueGroups = new Map();
        for (const item of list) {
          const code = Number(
            item.cropGroupCode ??
              item.CropGroupCode ??
             
              item.intCropGroupCode ??
              0
          );
          const name = String(
            item.cropGroupName ??
              item.CropGroupName ??
              ""
          ).trim();

          if (code > 0 && name && !uniqueGroups.has(code)) {
            uniqueGroups.set(code, { code, name });
          }
        }
        const groups = Array.from(uniqueGroups.values());

        setCropGroups(groups);
        console.log("Fetched crop groups:", groups);
       const defaultCropGroupCode =
  schemeCode === "5"
    ? 8
    : schemeCode === "48"
    ? 2
    : null;

const defaultGroup = groups.find(
  (g) => g.code === defaultCropGroupCode
);

if (defaultGroup) {
  setSelectedCropGroup(defaultGroup.code);
}
      } catch (err) {
        console.error("Error fetching crop groups:", err);
      } finally {
        if (schemeCode === "5") {
          setDashboardFiltersReady(true);
        }
      }
    };
    
   ["5", "48"].includes(schemeCode) && fetchCropGroups();
  }, [schemeCode, selectedSeason, selectedFinYear]);

  // Keep Crop Group in sync with Season changes (avoid stale selection).
  useEffect(() => {
    if (schemeCode !== "5") return;
    if (isFirstSeasonEffect.current) {
      isFirstSeasonEffect.current = false;
      return;
    }
    setDashboardFiltersReady(false);
    setSelectedCropGroup(0);
  }, [schemeCode, selectedSeason]);
//Rupali Crop Group Dropdown
  // Handle option change for Seed Demonstration and load count via API
    const handleAssetsOptionChange = (value) => {
    setSelectedAssetsOption(value);
    setShowAllAssetRows(false);
    setAssetsVisible(false);
  };
  const handleSeedDemoOptionChange = async (value) => {
    const val = Number(value);
    setSelectedOption(val);

    // Start loader
    setSeedDemoLoading(true);
    setSeedDemonstrationNew(null);

    // Clear any existing timers
    if (seedDemoIntervalRef.current) {
      clearInterval(seedDemoIntervalRef.current);
      seedDemoIntervalRef.current = null;
    }
    if (seedDemoTimeoutRef.current) {
      clearTimeout(seedDemoTimeoutRef.current);
      seedDemoTimeoutRef.current = null;
    }

    setseedDemoVisible(false);

    // Animate dots with setInterval
    seedDemoIntervalRef.current = setInterval(() => {
      setSeedDemoLoadingDots((d) => (d + 1) % 4);
    }, 400);

    try {
      const data = await fetchSeedDemoData(val);
      const apiCount = data?.recordCount ?? (Array.isArray(data?.dataContent) ? data.dataContent.length : 0) ?? 0;
      setSeedDemonstrationNew(apiCount);
    } catch (e) {
      console.error('Seed Demo option change fetch failed:', e);
      // keep count as null/previous; UI still shows table fallback if any
    } finally {
      setSeedDemoLoading(false);
      // Cleanup the interval
      if (seedDemoIntervalRef.current) {
        clearInterval(seedDemoIntervalRef.current);
        seedDemoIntervalRef.current = null;
      }
      setSeedDemoLoadingDots(0);
      // Clear timeout ref if any
      if (seedDemoTimeoutRef.current) {
        clearTimeout(seedDemoTimeoutRef.current);
        seedDemoTimeoutRef.current = null;
      }
    }
  };
  
    async function totalRecoredCount() {
        let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
    const roleCodeInt = parseInt(roleCode);
    const orgTypeCode = sessionStorage.getItem("orgTypeCode");
    const userCode = sessionStorage.getItem("userCodeModel");

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;

    const parm = {
      schemeCode,
      userCode,
      stateCode: roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3 ? (districtCode === "0" ? 0 : parseInt(districtCode)) : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "0"
            ? 0
            : parseInt(subDistrictCode)
                : 0,
        blockCode: Number(selectedBlock) || 0,
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
      orgTypeCode: orgTypeCode,
      userLevel: roleCodeInt,
      intSeasonCode : Number(selectedSeason),
      intCropGroupCode : Number(selectedCropGroup)
    };

    setSummaryCountLoading(true);
    try {
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/DashboardSurveyUserCount/SurveryUserCount`,
        parm
      );
      //console.log("datadatadata", data.dataContent);
      //console.log("surveyCount-------", data.dataContent[0].surveyCount);
      //console.log("userCount-------", data.dataContent[0].userCount);

      setSurveyCountNew(data.dataContent[0].surveyCount);
      setSurveyPlotCountNew(data.dataContent[0].totalPolygonCount);
      setSurveySeedDistricbution(data.dataContent[0].totalSeedDistribution);
      setSurveyRKVYAPI(data.dataContent[0].totalRKVYAPI);
      setUserCountNew(data.dataContent[0].userCount);
    } catch (error) {
      console.error("Error fetching NMEOOP details:", error);
    } finally {
      setSummaryCountLoading(false);
    }
  }

  async function totalPlotSurveyCount() {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    //  alert(sessionStorage.getItem("stateNameModel") );
    // alert(survey.districtCode);
    const baseURL =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_MODE
        : process.env.REACT_APP_PRO_MODE;

    const endpoint =
      schemeCode === "5"
        ? "/api/DashboardSurveyUserCount/SurveryUserCount"
        : "/api/NMEO_OP/getNMEOFarmerDetailsList";
    const payload = {
      schemeCode,
      stateCode: sessionStorage.getItem("stateCodeModel")
        ? sessionStorage.getItem("stateCodeModel")
        : "0",
      orgTypeCode: 1,
      lngA_FarmerCode: 0,
      str_MobileNo: "",
      int_State_Code: sessionStorage.getItem("stateCodeModel")
        ? sessionStorage.getItem("stateCodeModel")
        : "0",
      int_District_Code: sessionStorage.getItem("districtCodeModel")
        ? sessionStorage.getItem("districtCodeModel")
        : "0",
      int_SubDistrict_Code: sessionStorage.getItem("subDistrictCodeModel")
        ? sessionStorage.getItem("subDistrictCodeModel")
        : "0",
      int_Block_Code: 0,
      int_VillageCode: 0,
      lng_SurveyUserCode: 0,
    };

    try {
      const response = await axios.post(`${baseURL}${endpoint}`, payload);

      const allData = response?.data?.dataContent || [];

      const filteredData = allData.filter(
        (item) =>
          Array.isArray(item.farmerCropSurveyPolygonList) &&
          item.farmerCropSurveyPolygonList.length > 0
      );

      //console.log("Filtered Survey Data:", filteredData);
      setSurveyPlotCountNew(filteredData.length);
    } catch (error) {
      console.error("Error fetching survey data:", error);
    }
  }

  const handleRowToggle = async (index, survey) => {
    //alert();
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null); // collapse
      setExpandedRowData([]); // clear data when collapsing
    } else {
      setExpandedRowIndex(index); // expand
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      const stateCode = sessionStorage.getItem("stateCodeModel");
      const userCode = sessionStorage.getItem("userCodeModel");
      try {
        let parm = {
          schemeCode: schemeCode,
          userLevel: parseInt(userTypeCode) + 1,
          str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
        };

        // Handle parameters based on user type
        if (userTypeCode === "1") {
          // State Login
          parm = {
            ...parm,
            stateCode: survey.stateCode,
            districtCode: 0,
            subDistrictCode: 0,
          };
        } else if (userTypeCode === "2") {
          // District Login
          parm = {
            ...parm,
            stateCode: stateCode === "0" ? 0 : parseInt(stateCode),
            districtCode:
              survey.districtCode ||
              parseInt(sessionStorage.getItem("districtCodeModel")),
            subDistrictCode: 0,
          };
        } else if (userTypeCode === "3") {
          // Sub-District Login
          parm = {
            ...parm,
            stateCode: stateCode === "0" ? 0 : parseInt(stateCode),
            districtCode: parseInt(sessionStorage.getItem("districtCodeModel")),
            subDistrictCode: survey.subDistrictCode,
          };
        }

        // Convert any "null" strings to 0
        Object.keys(parm).forEach((key) => {
          if (parm[key] === "null" || parm[key] === null) {
            parm[key] = 0;
          }
        });

      //  console.log("Fetching expanded data with params:", parm);

        const { data } = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/SurveyCountGroupWise/UsersCountGroupWise`,
          parm
        );

        //console.log("Expanded row data received:", data);

        if (Array.isArray(data.dataContent)) {
          setExpandedRowData(data.dataContent);
        } else {
         // console.error("Invalid expanded data format received:", data);
          setExpandedRowData([]);
        }
      } catch (error) {
        //console.error("Error fetching expanded details:", error);
        setExpandedRowData([]);
      }
    }
  };
  const handlePdmcRowToggle = async (index, pdmc) => {
  if (expandedPdmcRowIndex === index) {
    setExpandedPdmcRowIndex(null);
    setExpandedPdmcRowData([]);
     setIsLoadingExpandedData(false);
  } else {
    setExpandedPdmcRowIndex(index);
    setIsLoadingExpandedData(true);
    setExpandedPdmcRowData([]);
    const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || "";
    const districtCode = sessionStorage.getItem("districtCodeModel") || "";

    try {
      let parm = {};

      if (userTypeCode === "1") {
        parm = {
          stateId: pdmc.stateCode || 0,
          districtId: 0,
          financialYear: selectedFinYear === "All" ? "" : selectedFinYear,
        };
      } else if (userTypeCode === "2") {
        parm = {
          stateId: stateCode === "0" ? "" : stateCode,
          districtId: pdmc.districtCode || districtCode || 0,
          financialYear: selectedFinYear === "All" ? "" : selectedFinYear,
        };
      } else if (userTypeCode === "3") {
        parm = {
          stateId: stateCode === "0" ? "" : stateCode,
          districtId: districtCode || 0,
          financialYear: selectedFinYear === "All" ? "" : selectedFinYear,
        };
      }

      Object.keys(parm).forEach((key) => {
        if (parm[key] === "null" || parm[key] === null) {
          parm[key] = "";
        }
      });

      console.log("Fetching PDMC expanded data with params:", parm);

          const { data } = await axios.post(
            `${
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/PDMC/PDMCReverseAPIExtn/FetchStateWisePDMCAPICount`,
            parm,
            {
              headers: {
                accept: "*/*",
                "Content-Type": "application/json",
              },
            }
          ); 

      console.log("PDMC Expanded row data received:", data);

      if (Array.isArray(data.dataContent)) {
        setExpandedPdmcRowData(data.dataContent);
      } else {
        console.error("Invalid PDMC expanded data format received:", data);
        setExpandedPdmcRowData([]);
      }
    } catch (error) {
      console.error("Error fetching PDMC expanded details:", error);
      setExpandedPdmcRowData([]);
    }
    finally {
      setIsLoadingExpandedData(false); 
    }
  }
};
 
const exportPdmcToCSV = () => {
  if (!latestPdmcCount || latestPdmcCount.length === 0) {
    alert("No PDMC data available to export.");
    return;
  }

  const userType = sessionStorage.getItem("userTypeCodeModel");
  let headers = ["Sr. No."];
  if (userType === "1") {
    headers.push("State Name");
  } else if (userType === "2") {
    headers.push("District Name");
  } else if (userType === "3") {
    headers.push("Sub District Name");
  }
  headers.push("Total Count");

  const csvRows = [headers.join(",")];

  latestPdmcCount.forEach((item, index) => {
    let row = [index + 1];
    if (userType === "1") {
      row.push(`"${item.stateName || "N/A"}"`);
    } else if (userType === "2") {
      row.push(`"${item.districtName || "N/A"}"`);
    } else if (userType === "3") {
      row.push(`"${item.subDistrictName || "N/A"}"`);
    }
    row.push(item.total || "0");  // Changed from totalPDMC to total
    csvRows.push(row.join(","));
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "PDMCReport.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
async function fetchPDMCData() {
  setPdmcCountLoading(true);
  try {
    const stateCode = sessionStorage.getItem("stateCodeModel") || "";
    const districtCode = sessionStorage.getItem("districtCodeModel") || "";
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    const roleCodeInt = parseInt(roleCode);

    const parm = {
      stateId: roleCode >= 2 
        ? (stateCode === "null" || stateCode === null ? "" : Number(stateCode))
        : 0,
      districtId: roleCode >= 3
        ? (districtCode === "null" || districtCode === null ? "" : Number(districtCode))
        : 0,
      financialYear: selectedFinYear === "All" ? "" : selectedFinYear,  
    };

    console.log("PDMC API Parameters:", parm);

  
    const { data } = await axios.post(
  `${
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_DEV_MODE
      : process.env.REACT_APP_PRO_MODE
  }/api/PDMC/PDMCReverseAPIExtn/FetchStateWisePDMCAPICount`,
  parm,
  {
    headers: {
          'accept': '*/*',
          'Content-Type': 'application/json'
        }
  }
);  

    console.log("PDMC API Response:", data);

    if (data && data.dataContent) {

      // // Calculate total from all state records
      // const totalCount = data.dataContent.reduce((sum, item) => {
      //   return sum + (parseInt(item.total) || 0);
      // }, 0);
      
      setPDMCAPICount(data.recordCount);
      setLatestPdmcCount(data.dataContent);
    } else {
      setPDMCAPICount(0);
      setLatestPdmcCount([]);
    }
  } catch (error) {
    console.error("Error fetching PDMC data:", error);
    setPDMCAPICount(0);
    setLatestPdmcCount([]);
  } finally {
    setPdmcCountLoading(false);
  }
}

  // const handleRowToggles = async (index, survey) => {
  //   console.log("survey----------", survey.stateCode);

  //   setExpandedRowDatas([]);
  //   if (expandedRowIndexs === index) {
  //     setExpandedRowIndexs(null); // collapse
  //     setExpandedRowDatas([]);
  //     setIsLoadingExpandedData(false); // Make sure to stop loading when collapsing
  //   } else {
  //     // Set the expanded row first
  //     setExpandedRowIndexs(index); // expand
  //     // Clear data immediately when switching to a different row
  //     setExpandedRowDatas([]);
  //     // Always fetch new data for the selected row
  //     setIsLoadingExpandedData(true); // Start loading
  //     const schemeCode = sessionStorage.getItem("schemeCodeModel");
  //     // only fetch if data not already loaded
  //     if (!expandedRowDatas[index]) {
  //       const parm = {
  //         schemeCode,
  //         stateCode: survey.stateCode,
  //         str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
  //         districtCode:
  //           sessionStorage.getItem("districtCodeModel") === "1"
  //             ? 0
  //             : survey.districtCode,
  //         subDistrictCode: "0",
  //         userLevel:
  //           sessionStorage.getItem("userTypeCodeModel") === "1" ? "2" : "3",
  //         userCode: sessionStorage.getItem("userCodeModel") || 0,
  //       };
  //       try {
  //         const { data } = await axios.post(
  //           `${
  //             process.env.NODE_ENV === "development"
  //               ? process.env.REACT_APP_DEV_MODE
  //               : process.env.REACT_APP_PRO_MODE
  //           }/api/SurveyCountGroupWise/SurveysCountGroupWise`,
  //           parm
  //         );
  //         console.log("datadatadata", data.dataContent);
  //         setExpandedRowDatas(data.dataContent);
  //       } catch (error) {
  //         console.error("Error fetching  details:", error);
  //       }
  //     }
  //   }
  // };
  const handleRowToggles = async (index, survey) => {
    //console.log("survey----------", survey.stateCode);

    if (expandedRowIndexs === index) {
      setExpandedRowIndexs(null); // collapse
      setExpandedRowDatas([]);
      setIsLoadingExpandedData(false); // Make sure to stop loading when collapsing
    } else {
      // Set the expanded row first
      setExpandedRowIndexs(index); // expand
      // Clear data immediately when switching to a different row
      setExpandedRowDatas([]);
      
      // Always fetch new data for the selected row
      setIsLoadingExpandedData(true); // Start loading
      
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
        const orgTypeCode = sessionStorage.getItem("orgTypeCode");
    const roleCodeInt = parseInt(roleCode); 
    const userCode = sessionStorage.getItem("userCodeModel");
      const parm = {
        schemeCode,
        stateCode: survey.stateCode,
        str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
        districtCode:
          sessionStorage.getItem("districtCodeModel") === "1"
            ? 0
            : survey.districtCode,
        subDistrictCode: "0",
        userLevel:
          sessionStorage.getItem("userTypeCodeModel") === "1" ? "2" : "3",
        userCode: userCode || 0,
      };
      
       
      const payloadForNMEOS  = {
    schemeCode,
    stateCode: survey.stateCode,
     districtCode:
          sessionStorage.getItem("districtCodeModel") === "1"
            ? 0
            : survey.districtCode,
        subDistrictCode: "0",
    userLevel:
          sessionStorage.getItem("userTypeCodeModel") === "1" ? "2" : "3",
     orgTypeCode: orgTypeCode,
      userCode: sessionStorage.getItem("userCodeModel") || 0,
    str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    intSeasonCode : selectedSeason,
    intCropGroupCode : selectedCropGroup,
  };
      
      try {
        const { data } = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/SurveyCountGroupWise/SurveysCountGroupWise`,
          schemeCode === "5" ? payloadForNMEOS : parm 
        );
       // console.log("datadatadata", data.dataContent);
        setExpandedRowDatas(data.dataContent || []);
      } catch (error) {
       // console.error("Error fetching details:", error);
        setExpandedRowDatas([]);
      } finally {
        //console.log("Setting loading to false"); // Debug log
        setIsLoadingExpandedData(false); // Stop loading
      }
    }
  };

  const handleRowTogglesForGT = async (index, survey) => {
    //console.log("survey----------", survey.stateCode);

    if (expandedRowIndexs === index) {
      setExpandedRowIndexs(null); // collapse
      setExpandedRowDatas([]); // Clear data when collapsing
    } else {
      setExpandedRowIndexs(index); // expand
  
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
        const orgTypeCode = sessionStorage.getItem("orgTypeCode");
    const roleCodeInt = parseInt(roleCode); 
    const userCode = sessionStorage.getItem("userCodeModel"); 
      // Only fetch if data not already loaded for this specific index
      if (!expandedRowDatas || expandedRowDatas.length === 0) {
        setIsLoadingExpandedData(true); 
        const parm = {
          schemeCode,
          stateCode: sessionStorage.getItem("stateCodeModel"),
          str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "1"
              ? 0
              : survey.districtCode,
          subDistrictCode: "0",
          userLevel:
            sessionStorage.getItem("userTypeCodeModel") === "1" ? "2" : "3",
          userCode: sessionStorage.getItem("userCodeModel") || 0,
        };
        
        try {
          const { data } = await axios.post(
            `${
              process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/SurveyCountGroupWise/SurveysCountGroupWise`,
            parm
          );
          //console.log("datadatadata", data.dataContent);
          setExpandedRowDatas(data.dataContent || []);
        } catch (error) {
          //console.error("Error fetching details:", error);
          setExpandedRowDatas([]); // Set empty array on error
        }
        finally {
          setIsLoadingExpandedData(false); // Stop loading
        }
      }
    }
  };

const handleRowTogglesForSeedDemo = async (index, survey, demoTypeArg) => {
  try {
    // Toggle collapse/expand
    if (expandedRowIndexs === index) {
      setExpandedRowIndexs(null);
      setExpandedRowDatas([]);
      return;
    }

    setExpandedRowIndexs(index);
    setExpandedRowDatas([]);
    setIsLoadingExpandedData(true);

    // Build params similar to fetchSeedDemoData, but prefer clicked row codes
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const roleCode = sessionStorage.getItem("userTypeCodeModel");
    const roleCodeInt = parseInt(roleCode, 10);
    const stateCodeSess = sessionStorage.getItem("stateCodeModel");
    const districtCodeSess = sessionStorage.getItem("districtCodeModel");
    const subDistrictCodeSess = sessionStorage.getItem("subDistrictCodeModel");
    

    const clickedState = Number(survey?.stateCode) || null;
    const clickedDistrict = Number(survey?.districtCode) || null;
    const clickedSubDistrict = Number(survey?.subDistrictCode) || null;

    const stateId =
      (clickedState ?? (roleCodeInt >= 2 ? Number(stateCodeSess) || 0 : 0)) || 0;
    const districtId =
      (clickedDistrict ?? (roleCodeInt >= 3 ? Number(districtCodeSess) || 0 : 0)) || 0;
    
    const subdistrictId = (clickedSubDistrict ?? (roleCodeInt >=4 ? Number(subDistrictCodeSess) || 0: 0)) || 0; 
    const parm = {
      schemeCode: Number(schemeCode) || 0,
      stateId,
      districtId,
      demoType: Number(demoTypeArg ?? selectedOption) || 1,
      subdistrictId,
      finYear: selectedFinYear === "All" ? "" : selectedFinYear,
    };

    const { data } = await axios.post(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Demonstration/FetchStateWiseDemonstrationCount`,
      parm,
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
      }
    );
     //console.log("The data is for row Togle for Seed Demo", data);
    setExpandedRowDatas(Array.isArray(data?.dataContent) ? data.dataContent : []);
  } catch (error) {
    //console.error("Error fetching Seed Demo expanded details:", error);
    setExpandedRowDatas([]);
  } finally {
    setIsLoadingExpandedData(false);
  }
};  
  async function surveysCountGroupWise() {
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
    const roleCodeInt = parseInt(roleCode);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictNameModel") || 0;
    const orgTypeCode = sessionStorage.getItem("orgTypeCode") || null;
    const userCode = sessionStorage.getItem("userCodeModel");
  const parm = {
      schemeCode,
      stateCode: roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null"
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null"
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      userLevel: roleCodeInt,
      orgTypeCode: orgTypeCode,
      userCode,
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    };
 const parmforRKVYKarnataka = {
      schemeCode,
      stateCode: roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null"
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null"
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      userLevel: roleCodeInt,
      // orgTypeCode: orgTypeCode,
      userCode,
      str_FinYear: selectedFinYear === 'All' ? '' : selectedFinYear
    };
    schemeCode === "12" &&  setLatestSurveyCount([]);

    // try {
    //   const { data } = await axios.post(
    //     `${
     try {
  setLatestSurveyLoading(true);
  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  const stateCode = sessionStorage.getItem("stateCodeModel");
 const url =
    `${process.env.NODE_ENV === "development"
       ? process.env.REACT_APP_DEV_MODE
       : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/SurveysCountGroupWise`;
  

  // choose request body (pass the object directly)
// const requestBody =
//   schemeCode === "15" && ["29"].includes(stateCode)
//     ? parmforRKVYKarnataka
//     : parm;

   let requestBody;

if (schemeCode === "15" && ["29"].includes(stateCode)) {
  requestBody = parmforRKVYKarnataka;
} else if (schemeCode === "5") {
  requestBody = {
    schemeCode,
    stateCode: roleCode >= 2 ? stateCode : 0,
    districtCode:
      roleCode >= 3
        ? districtCode === "null"
          ? 0
          : parseInt(districtCode)
        : 0,
    subDistrictCode:
      roleCode >= 4
        ? subDistrictCode === "null"
          ? 0
          : parseInt(subDistrictCode)
        : 0,
    userLevel: roleCodeInt,
     orgTypeCode: orgTypeCode,
    userCode,
    str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    intSeasonCode : selectedSeason,
    intCropGroupCode : selectedCropGroup
  };
} else {
  requestBody = parm;
}
  const { data } = await axios.post(url, requestBody);

  console.log("datadatadata", data?.dataContent);
  setLatestSurveyCount(data?.dataContent ?? []); // guard in case it's null

  if (
    (schemeCode === "8" && stateCode === "23") || (schemeCode === "15" && stateCode === "29") || (schemeCode === "22" && stateCode === "3") || (schemeCode === "6" && stateCode === "28")
    // (schemeCode === "15" && stateCode === "29") || 
    // (schemeCode === "15" && stateCode === "23")
  ){
    
    const arr = Array.isArray(data?.dataContent) ? data.dataContent : [];
    const totalSurvey = arr.reduce((sum, row) => sum + (Number(row?.totalSurvey) || 0), 0);

    console.log("Total Survey State:", data.dataContent);
    setstateAPIsurveyCount(totalSurvey);
  }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setLatestSurveyLoading(false);
    }
  }

  async function handleAddDataNMEOOP() {
    try {
      /** -------------------- 1. NMEO_OP_Details -------------------- **/
      const resultNMEO_OP = await NMEO_OP_Details();

      if (resultNMEO_OP.data.recordCount !== 0) {
        const filteredData = resultNMEO_OP.data.dataContent.filter(
          (item) =>
            Array.isArray(item.farmerCropSurveyPolygonList) &&
            item.farmerCropSurveyPolygonList.length > 0
        );

        setNmeoopCount(filteredData.length);
        setNmeoopData(filteredData);

        /** -------------------- 2. KECultivationFetchDetails -------------------- **/
        const resultKECultivation = await KECultivationFetchDetails();
        if (resultKECultivation.data.data.length > 0) {
          setKEcultivationCount(resultKECultivation.data.data.length);
          setKEcultivationData(resultKECultivation.data.data);
        }

        /** -------------------- 3. NMEO_3F_Perspective -------------------- **/
        const resultPalmOil = await NMEO_3F_Perspective();
        if (resultPalmOil.data.dataContent.length > 0) {
          setNMEO3FCount(resultPalmOil.data.dataContent.length);
          setNmeo3fData(resultPalmOil.data.dataContent);
        }

        /** -------------------- 4. Patanjali_data -------------------- **/
        const resultPatanjali = await Patanjali_data();
        if (resultPatanjali.data.data.length > 0) {
          parseKML(resultPatanjali.data.data[0].fileName);
        }
      }
    } catch (error) {
      console.error("Error in NMEO combined fetch:", error);
    }
  }

  function Patanjali_data() {
    return new Promise((resolve, reject) => {
      const stateValue = sessionStorage.getItem("stateCodeModel") || 0;

      const y = axios.post(
         `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/Patanjali/FetchKMLFilesbyStateCode`,
        {
          stateCode: stateValue === "NA" || stateValue === "" ? 0 : stateValue,
        }
      );
      resolve(y);
    });
  }

  const parseKML = async (file) => {
    try {
      console.log(file);
      // Fetch the KML file from the public folder
      const response = await fetch("/" + file);
      const kmlString = await response.text();

      // Parse KML to XML
      const parser = new DOMParser();
      const dom = parser.parseFromString(kmlString, "text/xml");

      // Convert KML to GeoJSON (using your `kml()` function)
      const geoJSON = kml(dom);

      // Update state with parsed data
      console.log("geoJSONgeoJSON", geoJSON.features.length);
      setPatanjaliCount(geoJSON.features.length);

      console.log("Parsed KML to GeoJSON:", geoJSON);
    } catch (error) {
      console.error("Error loading KML file:", error);
    }
  };

  function NMEO_3F_Perspective() {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    const roleCodeInt = parseInt(roleCode);

    const parm = {
      stateCode: roleCode >= 2 ? stateCode : "",
      DistrictCode:
        roleCode >= 3
          ? districtCode === "null"
            ? ""
            : parseInt(districtCode)
          : "",
      TehsilBlockCode: "0",
      VillageCode: "0",
      perspective: 1,
    };
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/GetFarmerDataByStateCode`,
        parm
      );
      resolve(y);
    });
  }

  function KECultivationFetchDetails() {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtNameModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictNameModel") || 0;
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    const roleCodeInt = parseInt(roleCode);

    const parm = {
      schemeCode,
      stateCode: 0, //roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null"
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null"
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      userLevel: roleCodeInt,
      orgTypeCode: 1,
      lngA_FarmerCode: 0,
      int_State_Code: parseInt(stateCode),
    };
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/reverse/CommonAPI/PostKECultivationFarmerDetails`,
        parm
      );
      resolve(y);
    });
  }

  function NMEO_OP_Details() {
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
  
    const roleCodeInt = parseInt(roleCode);
    //alert(sessionStorage.getItem("subDistrictCodeModel"));
    const parm = {
      schemeCode,
      stateCode: roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null"
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null"
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      userLevel: roleCodeInt,
      orgTypeCode: 1,
      lngA_FarmerCode: 0,
      int_State_Code: parseInt(stateCode),
    };

    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/NMEO_OP/getNMEOFarmerDetailsList`,
        parm
      );
      resolve(y);
    });
  }

  async function fetchRKVYData() {
    setRkvyCountLoading(true);
    try {
      const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
      const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
      let roleCode = sessionStorage.getItem("userTypeCodeModel");
      const roleCodeInt = parseInt(roleCode);

      const parm = {
        stateId:
          roleCode >= 2
            ? stateCode === "null" || stateCode === null
              ? ""
              : String(stateCode)
            : "",
        districtId:
          roleCode >= 3
            ? districtCode === "null" || districtCode === null
              ? ""
              : String(districtCode)
            : "",
      };

      //console.log("RKVY API Parameters:", parm);

      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchStateWiseRKVYCount`,
        parm
      );

      //console.log("RKVY API Response:", data);

      if (data && data.dataContent) {
        setRkvyCount(data.recordCount || data.dataContent.length);
        setLatestRkvyCount(data.dataContent);
      } else {
        setRkvyCount(0);
        setLatestRkvyCount([]);
      }
    } catch (error) {
      console.error("Error fetching RKVY data:", error);
      setRkvyCount(0);
      setLatestRkvyCount([]);
    } finally {
      setRkvyCountLoading(false);
    }
  }


async function fetchSeedDemoDropdown() {
  try {
    const { data } = await axios.get(
      `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Demonstration/GetDemonstrationTypeDropdown`,
      {
        headers: {
          'accept': '*/*'
        }
      }
    );
    
    if (data.success && data.dataContent) {
      setSeedDemoDropDown(data.dataContent);
    }
  } catch (error) {
    console.error('Error fetching seed demo data:', error);
    setSeedDemoDropDown([]);
  }
}

async function fetchSeedDemoData(demoTypeArg){
   try {
     const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
      const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
      let roleCode = sessionStorage.getItem("userTypeCodeModel");
      const schemeCode = sessionStorage.getItem("schemeCodeModel");
      const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;
      const roleCodeInt = parseInt(roleCode);

      const sId = roleCodeInt >= 2
        ? (stateCode === "null" || stateCode === null ? 0 : Number(stateCode) || 0)
        : 0;
      const dId = roleCodeInt >= 3
        ? (districtCode === "null" || districtCode === null ? 0 : Number(districtCode) || 0)
        : 0;
      const SubId = roleCodeInt >= 4
        ? (subDistrictCode === "null" || subDistrictCode === null ? 0 : Number(subDistrictCode) || 0)
         : 0;    
      const parm = {
        schemeCode: Number(schemeCode) || 0,
        stateId: sId,
        districtId: dId,
        demoType: Number(demoTypeArg ?? selectedOption) || 1,
        subdistrictId: SubId,
        finYear: selectedFinYear === "All" ? "" : selectedFinYear
      };

      // let parm ;
      // if(roleCode === "1"){
      //    parm = {
      //   schemeCode: Number(schemeCode) || 0,
      //   stateId: sId,
      //   districtId: dId,
      //   demoType: Number(demoTypeArg ?? selectedOption) || 1,
      // };
      // }
      // if(roleCode ==="2"){
      //     parm = {
      //   schemeCode: Number(schemeCode) || 0,
      //   stateId: sId,
      //   demoType: Number(demoTypeArg ?? selectedOption) || 1,
      // };
      // if(roleCode ==="3"){
      //   parm ={
      //     schemeCode: Number(schemeCode) || 0,
      //     stateId : sId,
      //     demoType : Number(demoTypeArg ?? selectedOption) || 1,
      //     districtId: dId,
      //   }
      // }

      //console.log("Fetch Seed Demo Data", parm);

      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Demonstration/FetchStateWiseDemonstrationCount`,
        parm,
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json',
          },
        }
      );

     // console.log("Seed Distribution Table API Response:", data);

      if (data && data.dataContent) {
        setDemoCount(data.recordCount || data.dataContent.length);
        setSeedDemoTable(data.dataContent);
      } else {
        setDemoCount(0);
        setSeedDemoTable([]);
      }

      return data;
   }
   catch (error) {
      console.error("Error fetching Seed Demonstration data:", error);
       setRkvyCount(0);
      setSeedDemoTable([]);
     
  }
}  

  const handleRkvyRowToggle = async (index, rkvy) => {
    if (expandedRkvyRowIndex === index) {
      setExpandedRkvyRowIndex(null); // collapse
      setExpandedRkvyRowData([]); // clear data when collapsing
    } else {
      setExpandedRkvyRowIndex(index); // expand
      const userTypeCode = sessionStorage.getItem("userTypeCodeModel");
      const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
      const districtCode = sessionStorage.getItem("districtCodeModel") || 0;

      try {
        let parm = {};

        // Handle parameters based on user type for RKVY
        if (userTypeCode === "1") {
          // State Login
          parm = {
            stateId: String(rkvy.stateCode) || "",
            districtId: "",
          };
        } else if (userTypeCode === "2") {
          // District Login
          parm = {
            stateId: stateCode === "0" ? "" : String(stateCode),
            districtId: String(rkvy.districtCode) || String(districtCode) || "",
          };
        } else if (userTypeCode === "3") {
          // Sub-District Login
          parm = {
            stateId: stateCode === "0" ? "" : String(stateCode),
            districtId: String(districtCode) || "",
          };
        }

        // Convert any "null" strings to empty strings
        Object.keys(parm).forEach((key) => {
          if (parm[key] === "null" || parm[key] === null) {
            parm[key] = "";
          }
        });

       // console.log("Fetching RKVY expanded data with params:", parm);

        const { data } = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/RKVY/RKVY/FetchStateWiseRKVYCount`,
          parm
        );
       // console.log("RKVY Expanded row data received:", data);

        if (Array.isArray(data.dataContent)) {
          setExpandedRkvyRowData(data.dataContent);
        } else {
          //console.error("Invalid RKVY expanded data format received:", data);
          setExpandedRkvyRowData([]);
        }
      } catch (error) {
        //console.error("Error fetching RKVY expanded details:", error);
        setExpandedRkvyRowData([]);
      }
    }
  };

  async function seedDistributionData() {
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
    const roleCodeInt = parseInt(roleCode);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel") || 0;
    const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel") || 0;
    const orgTypeCode = sessionStorage.getItem("orgTypeCode");
    const parm = {
      schemeCode,
      stateCode: roleCode >= 2 ? stateCode : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null"
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null"
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      userLevel: roleCodeInt,
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
      userCode: sessionStorage.getItem("userCodeModel") || 0,
    };
        const payloadForNMEOS  = {
    schemeCode,
    stateCode: roleCode >= 2 ? stateCode : 0,
    districtCode:
      roleCode >= 3
        ? districtCode === "null"
          ? 0
          : parseInt(districtCode)
        : 0,
    subDistrictCode:
      roleCode >= 4
        ? subDistrictCode === "null"
          ? 0
          : parseInt(subDistrictCode)
        : 0,
    userLevel: roleCodeInt,
    orgTypeCode: orgTypeCode,
   userCode: sessionStorage.getItem("userCodeModel") || 0,
    str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    intSeasonCode : selectedSeason,
intCropGroupCode : selectedCropGroup
  };

    try {
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SurveyCountGroupWise/SurveysCountGroupWise`,
        schemeCode === "5" ? payloadForNMEOS  :  parm
      );
      //console.log("datadatadata", data.dataContent);
      setLatestSurveyCount(data.dataContent);
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  }

  const exportSurveyToCSV = () => {
    if (!latestSurveyCount || latestSurveyCount.length === 0) {
      alert("No survey data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2") {
      headers.push("District Name");
    } else if (userType === "3") {
      headers.push("Sub District Name");
    }
    headers.push("Total Survey");
   {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && headers.push("Total Land Area(ha)");}

    const csvRows = [headers.join(",")];

    latestSurveyCount.forEach((item, index) => {
      let row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName}"`);
      } else if (userType === "2") {
        row.push(`"${item.districtName}"`);
      } else if (userType === "3") {
        row.push(`"${item.subDistrictName}"`);
      }
      row.push(item.totalSurvey);
     {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && row.push(item.totalSurveyArea);}
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "SurveyCountReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportStateAPISurveyToCSV = () => {
  if (!stateAPISurveyRows || stateAPISurveyRows.length === 0) {
    alert("No State API survey data available to export.");
    return;
  }

  const userType = sessionStorage.getItem("userTypeCodeModel");
  let headers = ["Sr. No."];

  if (userType === "1") {
    headers.push("State Name");
  } else if (userType === "2") {
    headers.push("District Name");
  } else if (userType === "3") {
    headers.push("Sub District Name");
  }

  headers.push("Total Survey");

  const csvRows = [headers.join(",")];

  stateAPISurveyRows.forEach((item, index) => {
    const row = [index + 1];

    if (userType === "1") {
      row.push(`"${item.stateName || ""}"`);
    } else if (userType === "2") {
      row.push(`"${item.districtName || ""}"`);
    } else if (userType === "3") {
      row.push(`"${item.subDistrictName || ""}"`);
    }

    row.push(item.totalSurvey ?? 0);
    csvRows.push(row.join(","));
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "StateAPISurveyCountReport.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


  async function userCountGroupWise() {
    const roleCode = sessionStorage.getItem("userTypeCodeModel");
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel");
    const districtCode = sessionStorage.getItem("districtCodeModel");
    const orgTypeCode = sessionStorage.getItem("orgTypeCode");
    //alert(stateCode);

    let parm = {
      schemeCode,
      userLevel: roleCode,
      //stateCode:sessionStorage.getItem("stateNameModel"),
      stateCode: stateCode === "0" ? 0 : parseInt(stateCode),
      districtCode: districtCode === "0" ? 0 : parseInt(districtCode),
      subDistrictCode: "0",
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
      // orgTypeCode:orgTypeCode,
      userCode: parseInt(sessionStorage.getItem("userCodeModel")) || 0,
    };

    try {
     // console.log("Fetching user count group data with params:", parm);
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SurveyCountGroupWise/UsersCountGroupWise`,
        parm
      );
     // console.log("User Count Group Data:", data.dataContent);
      if (Array.isArray(data.dataContent)) {
        setLatestUserCount(data.dataContent);
      } else {
        console.error("Invalid data format received:", data);
        setLatestUserCount([]);
      }
    } catch (error) {
      console.error("Error fetching user count details:", error);
      setLatestUserCount([]);
    }
  }

  const exportToCSV = () => {
    if (!latestUserCount || latestUserCount.length === 0) {
      alert("No data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2" || userType === "3") {
      headers.push("Sub District Name");
    }
    headers.push("No. of Users");

    let csvRows = [headers.join(",")];

    latestUserCount.forEach((item, index) => {
      let row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName}"`);
      } else if (userType === "2" || userType === "3") {
        row.push(`"${item.subDistrictName}"`);
      }
      row.push(item.totalUsers);
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "UserCountReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const fetchDataUser = async () => {
    //console.log("fetchDataUser");
    setActiveUserCountLoading(true);
    try {
      let result;
      if (
        sessionStorage.getItem("schemeCodeModel") !== "12" &&
        sessionStorage.getItem("schemeCodeModel") !== "13"
      ) {
        //console.log("Session Storage", sessionStorage.getItem("schemeCodeModel"));
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/Management/CommUsers/getFilterUsersExt`,
          {
            userCode: sessionStorage.getItem("userCodeModel"),
            //    "mobile": "string",
            stateCode: sessionStorage.getItem("stateCodeModel")
              ? sessionStorage.getItem("stateCodeModel")
              : 0,
            districtCode:
              sessionStorage.getItem("districtCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("districtCodeModel"),
            subDistrictCode:
              sessionStorage.getItem("subDistrictCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("subDistrictCodeModel"),
            blockCode: 0,
            //  "villageCode":  sessionStorage.getItem("villageModel") === "null" ? "" : sessionStorage.getItem("villageModel"),
            //    "userTypeCode": 0,
            schemeCode:
              sessionStorage.getItem("schemeCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("schemeCodeModel"),
            isVisible: "Y",
            isActive: "N",
            //    "orgTypeCode": "1"
          }
        );
        // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
        //console.log("count-------", result.data.recordCount);
        setUserCount(result.data.recordCount);
      } else {
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/gt/users/getUsersExtInternalUsers`,
          {
            userCode: sessionStorage.getItem("userCodeModel"),
            schemeCode:
              sessionStorage.getItem("schemeCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("schemeCodeModel"),

            //    "orgTypeCode": "1"
          }
        );

        //console.log("count-------", result.data.recordCount);
        setUserCount(result.data.recordCount);
      }
    } catch (error) {
      console.error("Error fetching user count:", error);
      setUserCount(0);
    } finally {
      setActiveUserCountLoading(false);
    }
  };

  const fetchDataFarmer = async () => {
    let result;
    let result1;
    if (sessionStorage.getItem("schemeCodeModel") === "5" || sessionStorage.getItem("schemeCodeModel") === "5") {
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 1,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
        }
      );
      setFarmerCount(result.data.recordCount);
    }
    if (sessionStorage.getItem("schemeCodeModel") === "14") {
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/NMEO_OP/getNMEOFarmerDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: 14,
          orgTypeCode: 1,
          lngA_FarmerCode: 0,
          str_MobileNo: "",
          int_State_Code: 0,
          int_District_Code: 0,
          int_SubDistrict_Code: 0,
          int_Block_Code: 0,
          int_VillageCode: 0,
          lng_SurveyUserCode: 0,
        }
      );
      setFarmerCount(result.data.recordCount);
    } else if (
      sessionStorage.getItem("schemeCodeModel") === "6" ||
      sessionStorage.getItem("schemeCodeModel") === "9"
    ) {
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsListNew`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode:
            sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode: sessionStorage.getItem("stateCodeModel")
            ? sessionStorage.getItem("stateCodeModel")
            : 0,
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );
      setFarmerCount(result.data.recordCount);
    } else if (sessionStorage.getItem("schemeCodeModel") === "7") {
      //console.log(
      //  "inside 3",
      //  sessionStorage.getItem("schemeCodeModel"),
      //  typeof sessionStorage.getItem("schemeCodeModel")
      //);

      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 4,
          SurveyUserCode:
            sessionStorage.getItem("schemeCodeModel") === "5" || sessionStorage.getItem("schemeCodeModel") === "48"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode: sessionStorage.getItem("stateCodeModel")
            ? sessionStorage.getItem("stateCodeModel")
            : 0,
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );

      //console.log("result", result);

      result1 = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 0,
          SurveyUserCode:
            sessionStorage.getItem("schemeCodeModel") === "5" || sessionStorage.getItem("schemeCodeModel") === "48"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode: sessionStorage.getItem("stateCodeModel")
            ? sessionStorage.getItem("stateCodeModel")
            : 0,
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );

      let DataContent = result.data.recordCount + result1.data.recordCount;

      setFarmerCount(DataContent);
    } else if (sessionStorage.getItem("schemeCodeModel") === "8") {
     // console.log("inside elese part");
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 0,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode: sessionStorage.getItem("stateCodeModel")
            ? sessionStorage.getItem("stateCodeModel")
            : 0,
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );
      setFarmerCount(result.data.recordCount);
    } else if (sessionStorage.getItem("schemeCodeModel") === "3") {
      //console.log(
      //  "inside 4",
      //  sessionStorage.getItem("schemeCodeModel"),
      //  typeof sessionStorage.getItem("schemeCodeModel")
      //);

      result1 = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 0,
          SurveyUserCode:
            sessionStorage.getItem("schemeCodeModel") === "5" || sessionStorage.getItem("schemeCodeModel") === "48"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode: sessionStorage.getItem("stateCodeModel")
            ? sessionStorage.getItem("stateCodeModel")
            : "0",
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );

      setFarmerCount(result1.data.recordCount);
    } else if (sessionStorage.getItem("schemeCodeModel") === "10") {
     // console.log("inside elese part");
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/CDB/CDB/GetCDBFarmerDetailsAsync`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
          orgTypeCode: 0,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : 0,
          stateCode:
            sessionStorage.getItem("stateCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("stateCodeModel"),
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );
      setFarmerCount(result.data.recordCount);
    } else if (sessionStorage.getItem("schemeCodeModel") === "11") {
     // console.log("inside elese part");
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode: 0,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode:
            sessionStorage.getItem("stateCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("stateCodeModel"),
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );
      setFarmerCount(result.data.recordCount);
    } else if (sessionStorage.getItem("schemeCodeModel") === "12") {
      if (sessionStorage.getItem("userTypeCodeModel") === "5") {
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/GT/GetSurveyDetailsGTTotal`,
          {
            CreatedBy:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            UperLevelUserCode: "0",
          }
        );
      } else {
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/GT/GetSurveyDetailsGTTotal`,
          {
            CreatedBy:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            UperLevelUserCode:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
          }
        );
      }
      setFarmerCount(result.data.dataContent[0].totalSurvey);
    } else if (sessionStorage.getItem("schemeCodeModel") === "13") {
     // console.log("inside elese part 13");

      if (sessionStorage.getItem("userTypeCodeModel") === "5") {
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/CropInsurance/GetSurveyDetailsCHTotal`,
          {
            CreatedBy:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            UperLevelUserCode:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            SchemeCode: "13",
          }
        );
      } else {
        result = await axios.post(
          `${
            process.env.NODE_ENV === "development"
              ? process.env.REACT_APP_DEV_MODE
              : process.env.REACT_APP_PRO_MODE
          }/api/CropInsurance/GetSurveyDetailsCHTotal`,
          {
            CreatedBy:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            UperLevelUserCode:
              sessionStorage.getItem("userCodeModel") === "null"
                ? 0
                : sessionStorage.getItem("userCodeModel"),
            SchemeCode: "13",
          }
        );
      }
      setFarmerCount(result.data.dataContent[0].totalSurvey);
    } else {
      //console.log(
      //  "inside 5",
      //  sessionStorage.getItem("schemeCodeModel"),
      //  typeof sessionStorage.getItem("schemeCodeModel")
      //);
      result = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {
          // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
          schemeCode: sessionStorage.getItem("schemeCodeModel"),
          orgTypeCode:
            sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
          SurveyUserCode:
            sessionStorage.getItem("userTypeCodeModel") === "5"
              ? sessionStorage.getItem("userCodeModel")
              : "0",
          stateCode:
            sessionStorage.getItem("stateCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("stateCodeModel"),
          districtCode:
            sessionStorage.getItem("districtCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("districtCodeModel"),
          subDistrictCode:
            sessionStorage.getItem("subDistrictCodeModel") === "null"
              ? 0
              : sessionStorage.getItem("subDistrictCodeModel"),
          // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")
        }
      );

      setFarmerCount(result.data.recordCount);
    }

    // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);
  };

  async function polygonCountGroupWise() {
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
    const roleCodeInt = parseInt(roleCode);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel");
    const districtCode = sessionStorage.getItem("districtCodeModel");
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel");

    const parm = {
      schemeCode: parseInt(schemeCode),
      userLevel: roleCodeInt,
      stateCode:
        roleCode >= 2
          ? stateCode === "null" || stateCode === null
            ? 0
            : parseInt(stateCode)
          : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null" || districtCode === null
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null" || subDistrictCode === null
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
    ...(schemeCode) === "5"
    ? {
        intSeasonCode: selectedSeason,
        intCropGroupCode: selectedCropGroup,
      }
    : {},
    };

    try {
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SurveyCountGroupWise/PolygonCountGroupWise`,
        parm
      );
     // console.log("Polygon count data:", data.dataContent);
      //console.log("Full API response:", data);
      setLatestPolygonCount(data.dataContent);
    } catch (error) {
      console.error("Error fetching polygon count details:", error);
    }
  }

  async function seedDistributionCountGroupWise() {
    let roleCode = sessionStorage.getItem("userTypeCodeModel");
    if (roleCode === "6") {
      roleCode = "3";
    }
    const roleCodeInt = parseInt(roleCode);

    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const stateCode = sessionStorage.getItem("stateCodeModel");
    const districtCode = sessionStorage.getItem("districtCodeModel");
    const subDistrictCode = sessionStorage.getItem("subDistrictCodeModel");

    const parm = {
      schemeCode: parseInt(schemeCode),
      userLevel: roleCodeInt,
      stateCode:
        roleCode >= 2
          ? stateCode === "null" || stateCode === null
            ? 0
            : parseInt(stateCode)
          : 0,
      districtCode:
        roleCode >= 3
          ? districtCode === "null" || districtCode === null
            ? 0
            : parseInt(districtCode)
          : 0,
      subDistrictCode:
        roleCode >= 4
          ? subDistrictCode === "null" || subDistrictCode === null
            ? 0
            : parseInt(subDistrictCode)
          : 0,
      str_FinYear: selectedFinYear === "All" ? "" : selectedFinYear,
      ...(schemeCode) === "5"
    ? {
        intSeasonCode: selectedSeason,
        intCropGroupCode: selectedCropGroup,
      }
    : {},
    };

    try {
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SurveyCountGroupWise/SeedDistributionCountGroupWise`,
        parm
      );
      //console.log("Seed distribution data:", data.dataContent);
     // console.log("Full seed API response:", data);
      setLatestSeedCount(data.dataContent);
    } catch (error) {
      console.error("Error fetching seed distribution details:", error);
    }
  }

  // Function to handle More Info clicks
  const handleMoreInfoClick = async (type) => {

    if (type === "seedDemo" && seedDemoLoading) {
      return;
    }
    // If data not loaded, load it first
    if (!initialDataLoaded) {
      await userCountGroupWise();
      setInitialDataLoaded(true);
    }

    // Determine if clicked div is currently open
    const isUserOpen = userVisible;
    const isSurveyOpen = surveyVisible;
    const isSeedOpen = seedVisible;
    const isPolygonOpen = polygonVisible;
    const isRkvyOpen = rkvyVisible;
    const isSeedDemoOpen = seedDemoVisible;
    const isAssetsOpen = assetsVisible;
    const isPdmcOpen = pdmcVisible;
    // Logic to toggle the clicked div and close others
    switch (type) {
      case "user":
        setUserVisible(!isUserOpen);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "survey":
        setUserVisible(false);
        setSurveyVisible(!isSurveyOpen);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "seed":
        await seedDistributionCountGroupWise();
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(!isSeedOpen);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "polygon":
        await polygonCountGroupWise();
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(!isPolygonOpen);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "RKVYAPI":
        await fetchRKVYData();
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(!isRkvyOpen);
        setseedDemoVisible(false);
        setAssetsVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "assets":
        setShowAllAssetRows(false);
        setAssetsVisible(!isAssetsOpen);
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "seedDemo":
        if (!isSeedDemoOpen) {
          setExpandedRowIndexs(null);
          setExpandedRowDatas([]);
          setIsLoadingExpandedData(false);
        }
        setseedDemoVisible(!isSeedDemoOpen);
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setPdmcVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "PDMCAPI": // ✅ Add complete case
        if (!isPdmcOpen) {
          setExpandedPdmcRowIndex(null);
          setExpandedPdmcRowData([]);
          setIsLoadingExpandedData(false);
        }
        // await fetchPDMCData();
        setPdmcVisible(!isPdmcOpen);
        setUserVisible(false);
        setSurveyVisible(false);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setseedDemoVisible(false);
        setAssetsVisible(false);
        setStateAPISurveyVisible(false);
        break;
      case "stateAPI":
        await fetchStateAPISeprateSurveyCount();
        setUserVisible(false);
        setSurveyVisible(false);
        setStateAPISurveyVisible(!stateAPISurveyVisible);
        setSeedVisible(false);
        setPolygonVisible(false);
        setRkvyVisible(false);
        setAssetsVisible(false);
        setseedDemoVisible(false);
        setPdmcVisible(false);
        break;
    }
  };

  const exportPolygonToCSV = () => {
    if (!latestPolygonCount || latestPolygonCount.length === 0) {
      alert("No polygon data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2") {
      headers.push("District Name");
    } else if (userType === "3") {
      headers.push("Sub District Name");
    }
    headers.push("Total Polygon");

    const csvRows = [headers.join(",")];

    latestPolygonCount.forEach((item, index) => {
      let row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName}"`);
      } else if (userType === "2") {
        row.push(`"${item.districtName}"`);
      } else if (userType === "3") {
        row.push(`"${item.subDistrictName}"`);
      }
      row.push(item.totalSurvey);
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "PolygonCountReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportSeedToCSV = () => {
    if (!latestSeedCount || latestSeedCount.length === 0) {
      alert("No seed distribution data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2") {
      headers.push("District Name");
    } else if (userType === "3") {
      headers.push("Sub District Name");
    }
    headers.push("Total Seed Distribution(kg)");

    const csvRows = [headers.join(",")];

    latestSeedCount.forEach((item, index) => {
      let row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName}"`);
      } else if (userType === "2") {
        row.push(`"${item.districtName}"`);
      } else if (userType === "3") {
        row.push(`"${item.subDistrictName}"`);
      }
      row.push(item.totalSurvey);
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "SeedDistributionReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportRkvyToCSV = () => {
    if (!latestRkvyCount || latestRkvyCount.length === 0) {
      alert("No RKVY data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2") {
      headers.push("District Name");
    } else if (userType === "3") {
      headers.push("Sub District Name");
    }
    headers.push("Project Name", "Project Code", "Status");

    const csvRows = [headers.join(",")];

    latestRkvyCount.forEach((item, index) => {
      let row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName || "N/A"}"`);
      } else if (userType === "2") {
        row.push(`"${item.districtName || "N/A"}"`);
      } else if (userType === "3") {
        row.push(`"${item.subDistrictName || "N/A"}"`);
      }
      row.push(`"${item.projectName || "N/A"}"`);
      row.push(`"${item.projectCode || "N/A"}"`);
      row.push(`"${item.status || "N/A"}"`);
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "RKVYProjectReport.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportSeedDemonstrationCountToCSV = () => {
    if (!seedDemoTable || seedDemoTable.length === 0) {
      alert("No Seed Demonstration data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    const schemeName = sessionStorage.getItem("currentSchemeName") || "";
    const stateName = sessionStorage.getItem("currentStateName") || "";
    const districtName = sessionStorage.getItem("currentDistrictName") || "";
    const typeName = (seedDemoDropDown || []).find((it) => Number(it.typeId) === Number(selectedOption))?.typeName || "SD";
    const today = new Date();
    const dateStr = today.toISOString().split("T")[0];
    const timeStr = today.toTimeString().split(" ")[0];

    // Metadata header rows
    const csvRows = [];
    csvRows.push(["Report", "Seed Demonstration Count"].join(","));
    csvRows.push(["Type", `"${typeName}"`].join(","));
    if (schemeName) csvRows.push(["Scheme Name", `"${schemeName}"`].join(","));
    if (stateName) csvRows.push(["State", `"${stateName}"`].join(","));
    if (districtName) csvRows.push(["District", `"${districtName}"`].join(","));
    
    csvRows.push(["Generated At", `"${dateStr} ${timeStr}"`].join(","));
    csvRows.push("");
    // Table headers
    let headers = ["Sr. No."];
    if (userType === "1") {
      headers.push("State Name");
    } else if (userType === "2") {
      headers.push("District Name");
    } else if (userType === "3") {
      headers.push("Sub District Name");
    }
    else if(userType === "4" || userType === "5"){
      headers.push("Village");
    }
    headers.push(
      "Total Demonstration",
      "Total Farmers",
      "Input",
      "Polygons Created",
      "Output",
      "Demo Area (Ha)"
    );

    csvRows.push(headers.join(","));

    seedDemoTable.forEach((item, index) => {
      const row = [index + 1];
      if (userType === "1") {
        row.push(`"${item.stateName || "N/A"}"`);
      } else if (userType === "2") {
        row.push(`"${item.districtName || "N/A"}"`);
      } else if (userType === "3") {
        row.push(`"${item.subDistrictName || "N/A"}"`);
      }
      else if(userType === "4" || userType === "5" ) {
        row.push(`"${item.villageName || "N/A"}"`);
      }
      row.push(
        item.totalDemonstration ?? 0,
        item.totalFarmers ?? 0,
        item.inputCount ?? 0,
        item.polygonsCreated ?? 0,
        item.outputCount ?? 0,
        item.demoArea ?? 0
      );
      csvRows.push(row.join(","));
    });

    // Totals row
    const totals = seedDemoTable.reduce(
      (acc, item) => {
        acc.dem += Number(item.totalDemonstration || 0);
        acc.far += Number(item.totalFarmers || 0);
        acc.inp += Number(item.inputCount || 0);
        acc.poly += Number(item.polygonsCreated || 0);
        acc.out += Number(item.outputCount || 0);
        acc.area += Number(item.demoArea || 0);
        return acc;
      },
      { dem: 0, far: 0, inp: 0, poly: 0, out: 0, area: 0 }
    );
    csvRows.push("");
    const totalsRow = ["Totals"];
    if (userType === "1" || userType === "2" || userType === "3"|| userType === "4"|| userType === "5") {
      totalsRow.push("");
    }
    totalsRow.push(
      totals.dem,
      totals.far,
      totals.inp,
      totals.poly,
      totals.out,
      totals.area
    );
    csvRows.push(totalsRow.join(","));

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    const safeType = String(typeName).replace(/[^\w-]+/g, "_");
    link.setAttribute("download", `SeedDemonstrationCount_${safeType}_${dateStr}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportAssetsCountToCSV = () => {
    if (!assetsTable || assetsTable.length === 0) {
      alert("No Assets data available to export.");
      return;
    }

    const userType = sessionStorage.getItem("userTypeCodeModel");
    const schemeName = sessionStorage.getItem("currentSchemeName") || "";
    const stateName = sessionStorage.getItem("currentStateName") || "";
    const districtName = sessionStorage.getItem("currentDistrictName") || "";
    const today = new Date();
    const dateStr = today.toISOString().split("T")[0];
    const timeStr = today.toTimeString().split(" ")[0];

    const csvRows = [];
    csvRows.push(["Report", "Assets Count"].join(","));
    if (schemeName) csvRows.push(["Scheme Name", `"${schemeName}"`].join(","));
    if (stateName) csvRows.push(["State", `"${stateName}"`].join(","));
    if (districtName) csvRows.push(["District", `"${districtName}"`].join(","));
    csvRows.push(["Generated At", `"${dateStr} ${timeStr}"`].join(","));
    csvRows.push("");

    let headers = ["Sr. No."];
    if (userType === "1") headers.push("State Name");
    else if (userType === "2") headers.push("District Name");
    else if (userType === "3") headers.push("Sub District Name");
    headers.push("Count");
    csvRows.push(headers.join(","));

    assetsTable.forEach((asset, index) => {
      const row = [index + 1];
      if (userType === "1") row.push(`"${asset.stateName || "N/A"}"`);
      else if (userType === "2") row.push(`"${asset.districtName || "N/A"}"`);
      else if (userType === "3") row.push(`"${asset.subDistrictName || "N/A"}"`);
      row.push(asset.totalAssets ?? asset.totalAssetsAdded ?? 0);
      csvRows.push(row.join(","));
    });

    const totalCount = assetsTable.reduce(
      (acc, asset) => acc + Number(asset.totalAssets ?? asset.totalAssetsAdded ?? 0),
      0
    );
    csvRows.push("");
    const totalsRow = ["Totals"];
    if (userType === "1" || userType === "2" || userType === "3") totalsRow.push("");
    totalsRow.push(totalCount);
    csvRows.push(totalsRow.join(","));

    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `AssetsCount_${dateStr}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function formatNumber(num) {
  // Convert number to string
  const str = num.toString();

  // Split integer and decimal part
  const [integer, decimal] = str.split(".");

  // Format last 3 digits first
  let lastThree = integer.slice(-3);
  let otherNumbers = integer.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  // Insert commas every 2 digits in the remaining part
  const formatted =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  // Add decimal part back if exists
  return decimal ? formatted + "." + decimal : formatted;
}


  return (
    <>
      <AdminHeaderNew />
      <AdminSideBarNew />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Dashboard</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>

          {/*{sessionStorage.getItem("userTypeCodeModel") === "3" && (*/}
          {/*    <div className='col-md-4'>*/}
          {/*    <label className="form-label">Select Dist</label><label style={{ color: "red" }}>*</label>*/}

          {/*    <select*/}
          {/*        className="form-select"*/}
          {/*        value={String(selectedDistrict || "")}*/}
          {/*        onChange={handleDistrictChange}*/}
          {/*    >*/}
          {/*        */}
          {/* <option value="">Choose District...</option> */}
          {/*        {[...(retrievedArray || [])]*/}
          {/*            .sort((a, b) =>*/}
          {/*                String(a.name || "").localeCompare(String(b.name || ""), undefined, { sensitivity: "base" })*/}
          {/*            )*/}
          {/*            .map((district, index) => (*/}
          {/*                <option key={index} value={String(district.code)}>*/}
          {/*                    {district.name} ({district.code})*/}
          {/*                </option>*/}
          {/*            ))}*/}
          {/*    </select>*/}
          {/*    </div>*/}
          {/*)*/}
          {/*}*/}
        </div>

        <div
          className="row mb-4 flitertag justify-content-end"
          style={{ marginTop: "-55px" }}
        >
          <div className="col-md-3">
            {sessionStorage.getItem("userTypeCodeModel") === "4" &&
              isSchemeBlocked && (
                <div className="col-md-12">
                  <label className="form-label text-white">
                    {!sessionStorage.getItem("subDistrictCodeModel")?.trim()
                      ? "Assigned Block"
                      : "Assigned Sub-District"}
                  </label>
                  &nbsp;
                  <label style={{ color: "red" }}>*</label>
                  {/*<label className="form-label text-white">*/}
                  {/*    {sessionStorage.getItem("schemeCodeModel") === "2" ? "Assigned Block" : "Assigned Sub-District"}*/}
                  {/*</label>&nbsp;<label style={{ color: "red" }}>*</label>*/}
                  {/*value={*/}
                  {/*    isBlockScheme*/}
                  {/*        ? String(selectedBlock || "")*/}
                  {/*        : String(selectedSubDistrict || "")*/}
                  <select
                    className="form-select"
                    value={
                      sessionStorage.getItem("schemeCodeModel") === "2" &&
                      !sessionStorage.getItem("subDistrictCodeModel")?.trim()
                        ? String(selectedBlock || "")
                        : String(selectedSubDistrict || "")
                    }
                    // onChange={handleSubDistrictChange}
                    onChange={
                      sessionStorage.getItem("schemeCodeModel") === "2" &&
                      !sessionStorage.getItem("subDistrictCodeModel")?.trim()
                        ? handleBlockChange
                        : handleSubDistrictChange
                    }
                  >
                    {/* <option value="">Choose District...</option> */}
                    {[...(retrievedArraySubDistrict || [])]
                      .sort((a, b) =>
                        String(a.name || "").localeCompare(
                          String(b.name || ""),
                          undefined,
                          { sensitivity: "base" }
                        )
                      )
                      .map((district, index) => (
                        <option key={index} value={String(district.code)}>
                          {district.name} ({district.code})
                        </option>
                      ))}
                  </select>
                </div>
              )}

            {sessionStorage.getItem("userTypeCodeModel") === "3" &&
              isSchemeBlocked && (
                <div className="col-md-12">
                  <label className="form-label text-white">
                    Assigned District
                  </label>
                  &nbsp;<label style={{ color: "red" }}>*</label>
                  <select
                    className="form-select"
                    value={String(selectedDistrict || "")}
                    onChange={handleDistrictChange}
                  >
                    {/* <option value="">Choose District...</option> */}
                    {[...(retrievedArray || [])]
                      .sort((a, b) =>
                        String(a.name || "").localeCompare(
                          String(b.name || ""),
                          undefined,
                          { sensitivity: "base" }
                        )
                      )
                      .map((district, index) => (
                        <option key={index} value={String(district.code)}>
                          {district.name} ({district.code})
                        </option>
                      ))}
                  </select>
                </div>
              )}
          </div>
          {["5", "48"].includes(schemeCode) && (
          //{schemeCode === "5" && (
            <div className="col-md-3">
              <div className="form-group text-white">
                <label htmlFor="season" className="form-label text-white">
                  Season
                </label>
                <select
                  id="season"
                  className="form-select finacildd_labelbox"
                  value={selectedSeason}
                  onChange={(e) => setSelectedSeason(Number(e.target.value))}
                  style={{
                    border: "1px solid white",
                    color: "white",
                    height: "36px",
                  }}
                >
                  <option value={0}>All</option>
                  {seasons.map((season) => (
                    <option
                      key={season.seasonCode}
                      value={season.seasonCode}
                      style={{ color: "black" }}
                    >
                      {season.seasonName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        
          {schemeCode === "5"  && (
            <div className="col-md-3">
              <div className="form-group text-white">
                <label htmlFor="season" className="form-label text-white">
                  Crop Group
                </label>
                <select
                  id="cropGroup"
                  className="form-select finacildd_labelbox"
                  value={selectedCropGroup}
                  onChange={(e) => setSelectedCropGroup(Number(e.target.value))}
                  style={{
                    border: "1px solid white",
                    color: "white",
                    height: "36px",
                  }}
                >
                  
                  {cropGroups.map((group) => (
                    <option key={group.code} value={group.code}>
  {group.name}
</option>
                  ))}
                </select>
              </div>
            </div>
          )}
          {schemeCode === "48"  && (
            <div className="col-md-3">
              <div className="form-group text-white">
                <label htmlFor="season" className="form-label text-white">
                  Crop Group
                </label>
                <select
                  id="cropGroup"
                  className="form-select finacildd_labelbox"
                  value={selectedCropGroup} 
                  onChange={(e) => setSelectedCropGroup(Number(e.target.value))}
                  disabled={true}
                  style={{
                    border: "1px solid white",
                    color: "white",
                    height: "36px",
                  }}
                >
                  
                  {cropGroups.map((group) => (
                    <option key={group.code} value={group.code}>
  {group.name}
</option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <div className="col-md-3">
            <div className="form-group text-white">
              <label htmlFor="finYear" className="form-label text-white">
                Financial Year
              </label>
              <select
                id="finYear"
                className="form-select finacildd_labelbox"
                value={selectedFinYear}
                onChange={(e) => setSelectedFinYear(e.target.value)}
                style={{
                  border: "1px solid white",
                  color: "white",
                  height: "36px",
                }}
              >
                {finYears.map((year) => (
                  <option key={year} value={year} style={{ color: "black" }}>
                    {year}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <section className="section dashboard">
          <div className="row">
            {sessionStorage.getItem("userTypeCodeModel") === "5" && sessionStorage.getItem("schemeCodeModel") === "48" ? (
              ""
            ) : (
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-danger card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">Active User </h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>

                      <div className="ps-3">
                        <h6 id="userCount">
                          {renderCardCount(
                            sessionStorage.getItem("schemeCodeModel") === "12" ||
                              sessionStorage.getItem("schemeCodeModel") ===
                                Number("12")
                              ? activeUserCountLoading
                              : summaryCountLoading,
                            sessionStorage.getItem("schemeCodeModel") === "12" ||
                              sessionStorage.getItem("schemeCodeModel") ===
                                Number("12")
                              ? userCount
                              : userCountNew >= 0
                              ? Math.max(0, Number(userCountNew) - 1)
                              : ""
                          )}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          sessionStorage.getItem("schemeCodeModel") === "12" ||
                          sessionStorage.getItem("schemeCodeModel") ===
                            Number("12")
                            ? activeUserCountLoading
                              ? undefined
                              : () => handleMoreInfoClick("user")
                            : summaryCountLoading
                            ? undefined
                            : () => handleMoreInfoClick("user")
                        }
                        title={
                          (sessionStorage.getItem("schemeCodeModel") === "12" ||
                          sessionStorage.getItem("schemeCodeModel") ===
                            Number("12")
                            ? activeUserCountLoading
                            : summaryCountLoading)
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={
                          sessionStorage.getItem("schemeCodeModel") === "12" ||
                          sessionStorage.getItem("schemeCodeModel") ===
                            Number("12")
                            ? activeUserCountLoading
                            : summaryCountLoading
                        }
                        aria-disabled={
                          sessionStorage.getItem("schemeCodeModel") === "12" ||
                          sessionStorage.getItem("schemeCodeModel") ===
                            Number("12")
                            ? activeUserCountLoading
                            : summaryCountLoading
                        }
                        style={
                          (sessionStorage.getItem("schemeCodeModel") === "12" ||
                          sessionStorage.getItem("schemeCodeModel") ===
                            Number("12")
                            ? activeUserCountLoading
                            : summaryCountLoading)
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
{sessionStorage.getItem("schemeCodeModel") !== "20" && (
            <div className="col-xxl-6 col-xl-6">
              <div className="card info-card sales-card bg-gradient-primary card-img-holder">
                <div className="card-body">
                  <img
                    src={Circles}
                    className="card-img-absolute"
                    alt="circle-image"
                  />
                  {sessionStorage.getItem("schemeCodeModel") === "5" || sessionStorage.getItem("schemeCodeModel") === "48" ? (
                    <h5 className="card-title">Total Farmer Registered</h5>
                  ) : (
                    <h5 className="card-title">Total Survey</h5>
                  )}
                  <div className="d-flex align-items-center">
                    <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                      <i>
                        <FontAwesomeIcon icon={faClipboardList} />{" "}
                      </i>
                    </div>
                    <div className="ps-3">
                      {/* {<h6 id="farmerCount">
                        {sessionStorage.getItem("schemeCodeModel") === "14" ||
                        sessionStorage.getItem("schemeCodeModel") === "5"
                          ? `${surveyCountNew}`
                          : isNaN(surveyCountNew) || surveyCountNew == null
                          ? 0
                          : surveyCountNew}
                      </h6>} */}
                      {
                        <h6 id="farmerCount">
                          {renderCardCount(
                            summaryCountLoading &&
                              !(
                                (sessionStorage.getItem("schemeCodeModel") ===
                                  "8" &&
                                  sessionStorage.getItem("stateCodeModel") ===
                                    "23") ||
                                (sessionStorage.getItem("schemeCodeModel") ===
                                  "15" &&
                                  sessionStorage.getItem("stateCodeModel") ===
                                    "29")
                              ),
                            (sessionStorage.getItem("schemeCodeModel") === "8" &&
                              sessionStorage.getItem("stateCodeModel") ===
                                "23") ||
                              (sessionStorage.getItem("schemeCodeModel") ===
                                "15" &&
                                sessionStorage.getItem("stateCodeModel") ===
                                  "29")
                              ? //     ||
                                // (sessionStorage.getItem("schemeCodeModel") === "15" &&
                                //   sessionStorage.getItem("stateCodeModel") === "23")
                                0
                              : sessionStorage.getItem("schemeCodeModel") ===
                                  "14" ||
                                sessionStorage.getItem("schemeCodeModel") ===
                                  "5"
                              ? `${surveyCountNew}`
                              : isNaN(surveyCountNew) || surveyCountNew == null
                              ? 0
                              : surveyCountNew
                          )}
                        </h6>
                      }
                    </div>
                  </div>
                  {/* <div className="mt-3">
                    <button
                      className="btn btn-link p-0 text-white"
                      onClick={() =>   handleMoreInfoClick("survey")}
                      title="Click for more information"
                    >
                      <i className="bi bi-arrow-right-circle-fill fs-6">
                        More Info
                      </i>
                    </button>
                  </div> */}
                  <div className="mt-3">
                    {" "}
                    <button
                      className="btn btn-link p-0 text-white"
                      disabled={
                        summaryCountLoading ||
                        (sessionStorage.getItem("schemeCodeModel") === "8" &&
                          sessionStorage.getItem("stateCodeModel") === "23") ||
                        (sessionStorage.getItem("schemeCodeModel") === "15" &&
                          sessionStorage.getItem("stateCodeModel") === "29")
                        //    ||
                        // (sessionStorage.getItem("schemeCodeModel") === "15" &&
                        //   sessionStorage.getItem("stateCodeModel") === "23")
                      }
                      aria-disabled={
                        summaryCountLoading ||
                        (sessionStorage.getItem("schemeCodeModel") === "8" &&
                          sessionStorage.getItem("stateCodeModel") === "23") ||
                        (sessionStorage.getItem("schemeCodeModel") === "15" &&
                          sessionStorage.getItem("stateCodeModel") === "29")
                        //    ||
                        // (sessionStorage.getItem("schemeCodeModel") === "15" &&
                        //   sessionStorage.getItem("stateCodeModel") === "23")
                      }
                      onClick={
                        summaryCountLoading ||
                        (sessionStorage.getItem("schemeCodeModel") === "8" &&
                          sessionStorage.getItem("stateCodeModel") === "23") ||
                        (sessionStorage.getItem("schemeCodeModel") === "15" &&
                          sessionStorage.getItem("stateCodeModel") === "29")
                          ? //    ||
                            // (sessionStorage.getItem("schemeCodeModel") === "15" &&
                            //   sessionStorage.getItem("stateCodeModel") === "23")
                            undefined
                          : () => handleMoreInfoClick("survey")
                      }
                      title={
                        summaryCountLoading
                          ? "Loading..."
                          : (sessionStorage.getItem("schemeCodeModel") === "8" &&
                              sessionStorage.getItem("stateCodeModel") ===
                                "23") ||
                            (sessionStorage.getItem("schemeCodeModel") ===
                              "15" &&
                              sessionStorage.getItem("stateCodeModel") === "29")
                          ? ""
                          : "Click for more information"
                      }
                      style={
                        summaryCountLoading ||
                        (sessionStorage.getItem("schemeCodeModel") === "8" &&
                          sessionStorage.getItem("stateCodeModel") === "23") ||
                        (sessionStorage.getItem("schemeCodeModel") === "15" &&
                          sessionStorage.getItem("stateCodeModel") === "29")
                          ? { opacity: 0.6, pointerEvents: "none" }
                          : undefined
                      }
                    >
                      {" "}
                      <i className="bi bi-arrow-right-circle-fill fs-6">
                        {" "}
                        More Info{" "}
                      </i>{" "}
                    </button>{" "}
                  </div>
                </div>
              </div>
            </div>
)}

            {((sessionStorage.getItem("schemeCodeModel") === "8" &&
              sessionStorage.getItem("stateCodeModel") === "23") ||
              (sessionStorage.getItem("schemeCodeModel") === "15" &&
                sessionStorage.getItem("stateCodeModel") === "29") ||
                (sessionStorage.getItem("schemeCodeModel") === "6" &&
                sessionStorage.getItem("stateCodeModel") === "3")) && 
                 (
                  
              // || (
              // sessionStorage.getItem("schemeCodeModel") === "14" &&
              // sessionStorage.getItem("stateCodeModel") === "36"
              // )
              //    ||
              // (sessionStorage.getItem("schemeCodeModel") === "15" &&
              //   sessionStorage.getItem("stateCodeModel") === "23")
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-deep-sea card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    {<h5 className="card-title">State API</h5>}
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faClipboardList} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="farmerCount">
                          {renderCardCount(
                            latestSurveyLoading,
                            stateAPISeprateSurveyCounts || 0
                          )}
                        </h6>
                      </div>
                    </div>

                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          latestSurveyLoading
                            ? undefined
                            : () => handleMoreInfoClick("survey")
                        }
                        title={
                          latestSurveyLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={latestSurveyLoading}
                        aria-disabled={latestSurveyLoading}
                        style={
                          latestSurveyLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {((sessionStorage.getItem("schemeCodeModel") === "14" &&
              sessionStorage.getItem("stateCodeModel") === "36") ||// ||  sessionStorage.getItem("stateCodeModel") === "29") ||
              (sessionStorage.getItem("schemeCodeModel") === "5" &&
                sessionStorage.getItem("stateCodeModel") === "34") ||
              (sessionStorage.getItem("schemeCodeModel") === "22" &&
                sessionStorage.getItem("stateCodeModel") === "3") ||
              (sessionStorage.getItem("schemeCodeModel") === "6" &&
                sessionStorage.getItem("stateCodeModel") === "28")
              ) && (
                <div className="col-xxl-6 col-xl-6">
                  <div className="card info-card sales-card bg-gradient-deep-sea card-img-holder">
                    <div className="card-body">
                      <img
                        src={Circles}
                        className="card-img-absolute"
                        alt="circle-image"
                      />
                      <h5 className="card-title">State API</h5>
                      <div className="d-flex align-items-center">
                        <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                          <i>
                            <FontAwesomeIcon icon={faClipboardList} />{" "}
                          </i>
                        </div>
                        <div className="ps-3">
                          <h6 id="farmerCount">
                            {renderCardCount(
                              stateApiCountLoading,
                              stateAPISeprateSurveyCount || 0
                            )}
                          </h6>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button
                          className="btn btn-link p-0 text-white"
                          onClick={
                            stateApiCountLoading
                              ? undefined
                              : () => handleMoreInfoClick("stateAPI")
                          }
                          title={
                            stateApiCountLoading
                              ? "Loading..."
                              : "Click for more information"
                          }
                          disabled={stateApiCountLoading}
                          aria-disabled={stateApiCountLoading}
                          style={
                            stateApiCountLoading
                              ? { opacity: 0.6, pointerEvents: "none" }
                              : undefined
                          }
                        >
                          <i className="bi bi-arrow-right-circle-fill fs-6">
                            More Info
                          </i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

            {["5", "48"].includes(sessionStorage.getItem("schemeCodeModel")) && (
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-primary card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">Seed Distribution</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="userCount">
                          {renderCardCount(
                            summaryCountLoading,
                            surveySeedDistricbution
                          )}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          summaryCountLoading
                            ? undefined
                            : () => handleMoreInfoClick("seed")
                        }
                        title={
                          summaryCountLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={summaryCountLoading}
                        aria-disabled={summaryCountLoading}
                        style={
                          summaryCountLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {sessionStorage.getItem("schemeCodeModel") === "15" && (
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-info card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">RKVY API (BHUVAN)</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="userCount">
                          {renderCardCount(rkvyCountLoading, rkvyCount)}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          rkvyCountLoading
                            ? undefined
                            : () => handleMoreInfoClick("RKVYAPI")
                        }
                        title={
                          rkvyCountLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={rkvyCountLoading}
                        aria-disabled={rkvyCountLoading}
                        style={
                          rkvyCountLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

           {["5", "48"].includes(sessionStorage.getItem("schemeCodeModel")) && (
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-danger card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">Polygon Created</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="userCount">
                          {renderCardCount(
                            summaryCountLoading,
                            surveyPlotCountNew
                          )}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          summaryCountLoading
                            ? undefined
                            : () => handleMoreInfoClick("polygon")
                        }
                        title={
                          summaryCountLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={summaryCountLoading}
                        aria-disabled={summaryCountLoading}
                        style={
                          summaryCountLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {validSchemeCodesForSeedDemonstration.includes(
              sessionStorage.getItem("schemeCodeModel")
            ) && (
              <div className="col-xxl-6 col-xl-6 ">
                <div className="card info-card sales-card bg-gradient-danger card-img-holder card-dropdown">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">Seed Demonstration</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="userCount">
                          {renderCardCount(
                            seedDemoLoading,
                            seedDemonstrationNew ?? 0
                          )}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={() => handleMoreInfoClick("seedDemo")}
                        title={
                          seedDemoLoading
                            ? "Loading…"
                            : "Click for more information"
                        }
                        disabled={seedDemoLoading}
                        aria-disabled={seedDemoLoading}
                        style={
                          seedDemoLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-2 dropdown me-2">
                    <label className="dropdown-title">Options</label>
                    <select
                      className="form-select"
                      value={selectedOption ?? ""}
                      onChange={(e) =>
                        handleSeedDemoOptionChange(e.target.value)
                      }
                    >
                      {/* <option value="">ALL</option> */}
                      {seedDemoDropDown.map((item) => (
                        <option key={item.typeId} value={item.typeId}>
                          {item.typeName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            )}
            {validSchemeCodesForAssetsCard.includes(
              sessionStorage.getItem("schemeCodeModel")
            ) && (
              <div className="col-xxl-6 col-xl-6 ">
                <div className="card info-card sales-card bg-gradient-info card-img-holder card-dropdown">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">Assets</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="assetsCount">
                          {renderCardCount(assetsLoading, assetsCount)}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={() => handleMoreInfoClick("assets")}
                        title={
                          assetsLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={assetsLoading}
                        aria-disabled={assetsLoading}
                        style={
                          assetsLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                  {/* <div className="col-md-3 dropdown me-2">
                    <label className="dropdown-title">Options</label>
                    <select
                      className="form-select"
                      value={selectedAssetsOption}
                      onChange={(e) => handleAssetsOptionChange(e.target.value)}
                      disabled={assetsLoading}
                    >
                      
                      {assetOptions.map((item) => (
                        <option key={item.typeId} value={item.typeId}>
                          {item.typeName}
                        </option>
                      ))}
                    </select>
                  </div> */}
                </div>
              </div>
            )}
            {/* 
            {schemeCode === "1" && 
             <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-info card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">PDMC API</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faUsers} />{" "}
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="userCount">{surveySeedDistricbution}</h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={() => handleMoreInfoClick("seed")}
                        title="Click for more information"
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div> } */}
            {schemeCode === "1" && (
              <div className="col-xxl-6 col-xl-6">
                <div className="card info-card sales-card bg-gradient-info card-img-holder">
                  <div className="card-body">
                    <img
                      src={Circles}
                      className="card-img-absolute"
                      alt="circle-image"
                    />
                    <h5 className="card-title">PDMC API</h5>
                    <div className="d-flex align-items-center">
                      <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                        <i>
                          <FontAwesomeIcon icon={faIndustry} />
                        </i>
                      </div>
                      <div className="ps-3">
                        <h6 id="pdmcCount">
                          {renderCardCount(pdmcCountLoading, pdmcAPICount)}
                        </h6>
                      </div>
                    </div>
                    <div className="mt-3">
                      <button
                        className="btn btn-link p-0 text-white"
                        onClick={
                          pdmcCountLoading
                            ? undefined
                            : () => handleMoreInfoClick("PDMCAPI")
                        }
                        title={
                          pdmcCountLoading
                            ? "Loading..."
                            : "Click for more information"
                        }
                        disabled={pdmcCountLoading}
                        aria-disabled={pdmcCountLoading}
                        style={
                          pdmcCountLoading
                            ? { opacity: 0.6, pointerEvents: "none" }
                            : undefined
                        }
                      >
                        <i className="bi bi-arrow-right-circle-fill fs-6">
                          More Info
                        </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {VillageName && (
              <div className="villname">
                <div>
                  <b>Assigned Villages:</b> {visibleVillages.join(", ")}
                </div>

                {villageList.length > 39 && (
                  <button
                    type="button"
                    onClick={() => setShowAllVillages((prev) => !prev)}
                    className="btn btn-link"
                  >
                    {showAllVillages ? "Show less" : "Show more"}
                  </button>
                )}
              </div>
            )}
            <div className="row usercount">
              {userVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">User Count</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th> District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>No. of Users</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && (
                                <th
                                  style={{ width: "50px", textAlign: "center" }}
                                >
                                  Action
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {latestUserCount && latestUserCount.length > 0 ? (
                              (showAll
                                ? latestUserCount
                                : latestUserCount.slice(0, 5)
                              ).map((survey, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && <td>{survey.stateName}</td>}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" && <td>{survey.districtName}</td>}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "3" && (
                                      <td>{survey.subDistrictName}</td>
                                    )}

                                    <td>{survey.totalUsers}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td style={{ textAlign: "center" }}>
                                        <span
                                          role="button"
                                          onClick={() =>
                                            handleRowToggle(index, survey)
                                          }
                                          style={{
                                            cursor: "pointer",
                                            color: "#0d6efd",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {expandedRowIndex === index
                                            ? "-"
                                            : "+"}
                                        </span>
                                      </td>
                                    )}
                                  </tr>
                                  {expandedRowIndex === index && (
                                    <tr>
                                      <td colSpan={9}>
                                        <div className="table-responsive">
                                          <table className="table table-hover table-primary">
                                            <thead>
                                              <tr>
                                                <th>Sr. No.</th>
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "1" && <th>District</th>}
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "2" && <th>Village</th>}
                                                <th>Total Users</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {Array.isArray(expandedRowData) &&
                                              expandedRowData.length > 0 ? (
                                                expandedRowData.map(
                                                  (surveyex, subIndex) => (
                                                    <tr key={subIndex}>
                                                      <td>{subIndex + 1}</td>
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "1" && (
                                                        <td>
                                                          {
                                                            surveyex.districtName
                                                          }
                                                        </td>
                                                      )}
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "2" && (
                                                        <td>
                                                          {surveyex.villageName}
                                                        </td>
                                                      )}
                                                      <td>
                                                        {surveyex.totalUsers ||
                                                          "N/A"}
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td colSpan={3}>
                                                    No data available
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {assetsTable && assetsTable.length > 10 && (
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() => setShowAllAssetRows(!showAllAssetRows)}
                          >
                            {showAllAssetRows ? "- Show Less" : "+ Show More"}
                          </button>
                        </div>
                      )}
                      {latestUserCount && latestUserCount.length > 5 && (
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() => setShowAll(!showAll)}
                          >
                            {showAll ? "Show Less" : "Show More"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {surveyVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Latest Survey Count</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportSurveyToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export Survey CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "4" && <th>Village Name</th>}
                              <th>Total Survey</th>
                              {sessionStorage.getItem("schemeCodeModel") ===
                                "14" && <th>Capture Area(ha)</th>}
                              {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && <th>Total Land Area(ha)</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>Action</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" &&
                                schemeCode === "12" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {(showAllSurveyRows
                              ? latestSurveyCount
                              : latestSurveyCount.slice(0, 5)
                            ).map((survey, index) => (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{index + 1}</td>
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "1" && <td>{survey.stateName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "2" && <td>{survey.districtName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "3" && (
                                    <td>{survey.subDistrictName}</td>
                                  )}
                                   {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "4" && (
                                    <td>{survey.villageName}</td>
                                  )}
                                  <td>{survey.totalSurvey}</td>
                                   {sessionStorage.getItem("schemeCodeModel") ===
                                "14" && <td>{Number(survey.totalSurveyArea).toFixed(2)}</td>}
                                  {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && <td>{Number(survey.totalSurveyArea).toFixed(2)}</td>}
                                  {(sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "1" ||
                                    (sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" &&
                                      schemeCode === "12")) && (
                                    <td>
                                      <a
                                        href="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          schemeCode === "12" &&
                                          sessionStorage.getItem(
                                            "userTypeCodeModel"
                                          ) === "2"
                                            ? handleRowTogglesForGT(
                                                index,
                                                survey
                                              )
                                            : handleRowToggles(index, survey);
                                        }}
                                      >
                                        <i
                                          className={`bi ${
                                            expandedRowIndexs === index
                                              ? "bi-dash"
                                              : "bi-plus"
                                          }`}
                                        ></i>
                                      </a>
                                    </td>
                                  )}
                                </tr>
                                {expandedRowIndexs === index && (
                                  <tr>
                                    <td colSpan={9}>
                                      <div className="table-responsive">
                                        <table className="table table-hover table-primary">
                                          <thead>
                                            <tr>
                                              <th>Sr. No.</th>
                                              {sessionStorage.getItem(
                                                "userTypeCodeModel"
                                              ) === "1" && <th>District</th>}
                                              {sessionStorage.getItem(
                                                "userTypeCodeModel"
                                              ) === "2" && (
                                                <th>Sub District</th>
                                              )}
                                              <th>Total Survey</th>
                                               {sessionStorage.getItem("schemeCodeModel") ===
                                "14" && <th>Capture Area(ha)</th>}
                                              {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && <th>Total Land Area(ha)</th>}
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {isLoadingExpandedData ? (
                                              <tr>
                                                <td
                                                  colSpan={3}
                                                  className="text-center py-4"
                                                >
                                                  <div className="d-flex justify-content-center align-items-center">
                                                    <div
                                                      className="spinner-border text-primary me-2"
                                                      role="status"
                                                    >
                                                      <span className="visually-hidden">
                                                        Loading...
                                                      </span>
                                                    </div>
                                                    <span>Loading data...</span>
                                                  </div>
                                                </td>
                                              </tr>
                                            ) : Array.isArray(
                                                expandedRowDatas
                                              ) &&
                                              expandedRowDatas.length > 0 ? (
                                              expandedRowDatas.map(
                                                (surveyex, subIndex) => (
                                                  <tr key={subIndex}>
                                                    <td>{subIndex + 1}</td>
                                                    {sessionStorage.getItem(
                                                      "userTypeCodeModel"
                                                    ) === "1" && (
                                                      <td>
                                                        {surveyex.districtName}
                                                      </td>
                                                    )}
                                                    {sessionStorage.getItem(
                                                      "userTypeCodeModel"
                                                    ) === "2" && (
                                                      <td>
                                                        {
                                                          surveyex.subDistrictName
                                                        }
                                                      </td>
                                                    )}
                                                    <td>
                                                      {surveyex.totalSurvey ||
                                                        "N/A"}
                                                    </td>
                                                    {sessionStorage.getItem("schemeCodeModel") ===
                                "14" &&  <td> {Number(surveyex.totalSurveyArea).toFixed(2)}</td>}
                                                    {sessionStorage.getItem("schemeCodeModel") ===
                                "2" && <td>
                                                     {Number(surveyex.totalSurveyArea).toFixed(2)}
                                                    </td>}
                                                  </tr>
                                                )
                                              )
                                            ) : (
                                              <tr>
                                                <td
                                                  colSpan={3}
                                                  className="text-center py-3"
                                                >
                                                  No data available
                                                </td>
                                              </tr>
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {latestSurveyCount.length > 5 && (
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() =>
                              setShowAllSurveyRows(!showAllSurveyRows)
                            }
                          >
                            {showAllSurveyRows ? "- Show Less" : "+ Show More"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {seedVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Seed Distribution Details</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportSeedToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export Seed CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>Total Seed Distribution(kg)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {latestSeedCount && latestSeedCount.length > 0 ? (
                              latestSeedCount.map((seed, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "1" && <td>{seed.stateName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "2" && <td>{seed.districtName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "3" && <td>{seed.subDistrictName}</td>}
                                  <td>{seed.totalSurvey}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No seed distribution data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {polygonVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Polygon Details</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportPolygonToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export Polygon CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>Total Polygon</th>
                            </tr>
                          </thead>
                          <tbody>
                            {latestPolygonCount &&
                            latestPolygonCount.length > 0 ? (
                              latestPolygonCount.map((polygon, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "1" && <td>{polygon.stateName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "2" && <td>{polygon.districtName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "3" && (
                                    <td>{polygon.subDistrictName}</td>
                                  )}
                                  <td>{polygon.totalSurvey}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No polygon data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {rkvyVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">RKVY Project Details</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportRkvyToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export RKVY CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>Total Survey</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {latestRkvyCount && latestRkvyCount.length > 0 ? (
                              (showAllRkvyRows
                                ? latestRkvyCount
                                : latestRkvyCount.slice(0, 5)
                              ).map((rkvy, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>{rkvy.stateName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" && (
                                      <td>{rkvy.districtName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "3" && (
                                      <td>{rkvy.subDistrictName || "N/A"}</td>
                                    )}
                                    <td>
                                      {rkvy.totalRKVY || rkvy.total || "1"}
                                    </td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleRkvyRowToggle(index, rkvy);
                                          }}
                                        >
                                          <i
                                            className={`bi ${
                                              expandedRkvyRowIndex === index
                                                ? "bi-dash"
                                                : "bi-plus"
                                            }`}
                                          ></i>
                                        </a>
                                      </td>
                                    )}
                                  </tr>
                                  {expandedRkvyRowIndex === index && (
                                    <tr>
                                      <td colSpan={9}>
                                        <div className="table-responsive">
                                          <table className="table table-hover table-primary">
                                            <thead>
                                              <tr>
                                                <th>Sr. No.</th>
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "1" && <th>District</th>}
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "2" && (
                                                  <th>Sub District</th>
                                                )}
                                                <th>Total Survey</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {Array.isArray(
                                                expandedRkvyRowData
                                              ) &&
                                              expandedRkvyRowData.length > 0 ? (
                                                expandedRkvyRowData.map(
                                                  (rkvyEx, subIndex) => (
                                                    <tr key={subIndex}>
                                                      <td>{subIndex + 1}</td>
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "1" && (
                                                        <td>
                                                          {rkvyEx.districtName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "2" && (
                                                        <td>
                                                          {rkvyEx.subDistrictName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      <td>
                                                        {rkvyEx.total ||
                                                          "N/A"}
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td colSpan={5}>
                                                    No data available
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No RKVY data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {latestRkvyCount && latestRkvyCount.length > 5 && (
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() => setShowAllRkvyRows(!showAllRkvyRows)}
                          >
                            {showAllRkvyRows ? "- Show Less" : "+ Show More"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {seedDemoVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">Seed Demonstration Count</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportSeedDemonstrationCountToCSV}
                            style={{ top: "9px", position: "absolute" }}
                          >
                            Export Seed Demonstration Count
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-center">
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              {/* <th>Total Assets</th> */}
                              {(sessionStorage.getItem("userTypeCodeModel") ===
                                "4" ||
                                sessionStorage.getItem("userTypeCodeModel") ===
                                  "5") && <th>Village</th>}

                              <th>Total Demonstration </th>
                              <th>Total Farmers </th>
                              <th>Input </th>
                              <th>Polygons Created </th>
                              <th>Output </th>
                              <th>Demo Area (Ha)</th>  
                              {(sessionStorage.getItem("userTypeCodeModel") ===
                                "1" ||
                                sessionStorage.getItem("userTypeCodeModel") ===
                                  "2" ||
                                sessionStorage.getItem("userTypeCodeModel") ===
                                  "3") && <th>Action</th>}
                                
                            </tr>
                          </thead>
                          <tbody>
                            {seedDemoTable && seedDemoTable.length > 0 ? (
                              (showAllSeedDemoRows // need to fix afterwards
                                ? seedDemoTable
                                : seedDemoTable.slice(0, 5)
                              ).map((seedDemo, index) => (
                                <React.Fragment key={index}>
                                  <tr className="text-center">
                                    <td>{index + 1}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>{seedDemo.stateName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" && (
                                      <td>{seedDemo.districtName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "3" && (
                                      <td>
                                        {seedDemo.subDistrictName || "N/A"}
                                      </td>
                                    )}
                                    {(sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "4" ||
                                      sessionStorage.getItem(
                                        "userTypeCodeModel"
                                      ) === "5") && (
                                      <td>{seedDemo.villageName}</td>
                                    )}
                                    {/* <td>{seedDemo.totalAssets ?? seedDemo.totalAssetsAdded ?? 0} </td> */}
                                    <td>
                                      {seedDemo.totalDemonstration || "0"}
                                    </td>

                                    <td> {seedDemo.totalFarmers || "0"}</td>
                                    <td> {seedDemo.inputCount || "0"}</td>
                                    <td> {seedDemo.polygonsCreated || "0"}</td>
                                    <td> {seedDemo.outputCount || "0"}</td>
                                    <td> {seedDemo.demoArea || "0"}</td>
                                    {(sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" ||
                                      sessionStorage.getItem(
                                        "userTypeCodeModel"
                                      ) === "2" ||
                                      sessionStorage.getItem(
                                        "userTypeCodeModel"
                                      ) === "3") && (
                                      <td>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleRowTogglesForSeedDemo(
                                              index,
                                              seedDemo,
                                              selectedOption
                                            );
                                          }}
                                        >
                                          <i
                                            className={`bi ${
                                              expandedRowIndexs === index
                                                ? "bi-dash"
                                                : "bi-plus"
                                            }`}
                                          ></i>
                                        </a>
                                      </td>
                                    )}
                                  </tr>
                                  {expandedRowIndexs === index && (
                                    <tr>
                                      <td colSpan={9}>
                                        <div className="table-responsive">
                                          <table className="table table-hover table-primary">
                                            <thead>
                                              <tr className="text-center">
                                                <th>Sr. No.</th>
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "1" && <th>District</th>}
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "2" && (
                                                  <th>Sub District</th>
                                                )}
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "3" && <th>Village</th>}
                                                <th>Total Demonstration</th>
                                                <th>Total Farmers</th>
                                                <th>Input</th>
                                                <th>Polygons Created</th>
                                                <th>Output</th>
                                                <th>Demo Area (Ha)</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {isLoadingExpandedData ? (
                                                <tr>
                                                  <td
                                                    colSpan={8}
                                                    className="text-center py-4"
                                                  >
                                                    <div className="d-flex justify-content-center align-items-center">
                                                      <div
                                                        className="spinner-border text-primary me-2"
                                                        role="status"
                                                      >
                                                        <span className="visually-hidden">
                                                          Loading...
                                                        </span>
                                                      </div>
                                                      <span>
                                                        Loading data...
                                                      </span>
                                                    </div>
                                                  </td>
                                                </tr>
                                              ) : Array.isArray(
                                                  expandedRowDatas
                                                ) &&
                                                expandedRowDatas.length > 0 ? (
                                                expandedRowDatas.map(
                                                  (seedDemoData, subIndex) => (
                                                    <tr
                                                      className="text-center"
                                                      key={subIndex}
                                                    >
                                                      <td>{subIndex + 1}</td>
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "1" && (
                                                        <td>
                                                          {seedDemoData.districtName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "2" && (
                                                        <td>
                                                          {seedDemoData.subDistrictName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "3" && (
                                                        <td>
                                                          {
                                                            seedDemoData.villageName
                                                          }
                                                        </td>
                                                      )}
                                                      <td>
                                                        {seedDemoData.totalDemonstration ||
                                                          "0"}
                                                      </td>
                                                      <td>
                                                        {seedDemoData.totalFarmers ||
                                                          "0"}
                                                      </td>
                                                      <td>
                                                        {seedDemoData.inputCount ||
                                                          "0"}
                                                      </td>
                                                      <td>
                                                        {seedDemoData.polygonsCreated ||
                                                          "0"}
                                                      </td>
                                                      <td>
                                                        {seedDemoData.outputCount ||
                                                          "0"}
                                                      </td>
                                                      <td>{seedDemoData.demoArea || "0"}</td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={7}
                                                    className="text-center"
                                                  >
                                                    No data available
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} className="text-center">
                                  No Seed Demonstration data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                        {seedDemoTable && seedDemoTable.length > 5 && (
                          <div className="text-center mt-2">
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => setShowAllSeedDemoRows(!showAllSeedDemoRows)}
                            >
                              {showAllSeedDemoRows ? "Show Less" : "Show More"}
                            </button>
                          </div>
                        )}    

                    {console.log("Seed Demonstration Table", seedDemoTable)}
                      {/* {assetsTable && assetsTable.length > 10 && (
                         
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() =>
                              setShowAllAssetRows(!showAllAssetRows)
                            }
                          >
                            {showAllAssetRows ? "- Show Less" : "+ Show More"}
                          </button>
                        </div>
                      )} */}
                     
                    </div>
                  </div>
                </div>
              )}
              
              {assetsVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">
                        {" "}
                        {/* {selectedAsset ? selectedAsset.typeName : "Asset"} Count */}
                        Assets Count
                      </h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportAssetsCountToCSV}
                            style={{ top: "9px", position: "absolute" }}
                          >
                            Export Assets Count
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr className="text-center">
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              {/* <th>Total Demonstration </th>
                                           <th>Total Farmers </th>
                                           <th>Input </th>
                                           <th>Polygons Created </th>
                                           <th>Output </th> */}
                              <th>Count</th>
                            </tr>
                          </thead>
                          <tbody>
                            {console.log("Assets table", assetsTable)}
                            {assetsTable && assetsTable.length > 0 ? (
                              assetsTable.map((asset, index) => (
                                <React.Fragment key={index}>
                                  <tr className="text-center">
                                    <td>{index + 1}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>{asset.stateName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" && (
                                      <td>{asset.districtName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "3" && (
                                      <td>{asset.subDistrictName || "N/A"}</td>
                                    )}
                                    <td>{asset.totalAssets ?? asset.totalAssetsAdded ?? 0}</td>
                                    {/* <td>
                                                   {asset.  || "0"}
                                                 </td> */}

                                    {/* <td> {seedDemo.totalFarmers  || "0"}</td>
                                                 <td> {seedDemo.inputCount  || "0"}</td>
                                                 <td> {seedDemo.polygonsCreated  || "0"}</td>
                                                 <td> {seedDemo.outputCount  || "0"}</td>
                                                   {sessionStorage.getItem(
                                                   "userTypeCodeModel"
                                                 ) === "1" && (
                                                   <td>
                                                     <a
                                                       href="#"
                                                       onClick={(e) => {
                                                         e.preventDefault();
                                                         handleRowTogglesForSeedDemo(index, seedDemo,selectedOption);
                                                       }}
                                                     >
                                                       <i
                                                         className={`bi ${
                                                           expandedRowIndexs=== index
                                                             ? "bi-dash"
                                                             : "bi-plus"
                                                         }`}
                                                       ></i>
                                                     </a>
                                                   </td>
                                                 )} */}
                                  </tr>
                                  {/* {expandedRowIndexs === index && (
                                                 <tr>
                                                   <td colSpan={9}>
                                                     <div className="table-responsive">
                                                       <table className="table table-hover table-primary">
                                                         <thead>
                                                           <tr className="text-center">
                                                             <th>Sr. No.</th>
                                                             {sessionStorage.getItem(
                                                               "userTypeCodeModel"
                                                             ) === "1" && <th>District</th>}
                                                             {sessionStorage.getItem(
                                                               "userTypeCodeModel"
                                                             ) === "2" && (
                                                               <th>Sub District</th>
                                                             )}
                                                             <th>Total Demonstration</th>
                                                             <th>Total Farmers</th>
                                                             <th>Input</th>
                                                             <th>Polygons Created</th>
                                                             <th>Output</th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                           {isLoadingExpandedData ? (
                                                             <tr>
                                                               <td colSpan={7} className="text-center py-4">
                                                                 <div className="d-flex justify-content-center align-items-center">
                                                                   <div className="spinner-border text-primary me-2" role="status">
                                                                     <span className="visually-hidden">Loading...</span>
                                                                   </div>
                                                                   <span>Loading data...</span>
                                                                 </div>
                                                               </td>
                                                             </tr>
                                                           ) : Array.isArray(expandedRowDatas) && expandedRowDatas.length > 0 ? (
                                                             expandedRowDatas.map((seedDemoData, subIndex) => (
                                                               <tr className="text-center" key={subIndex}>
                                                                 <td>{subIndex + 1}</td>
                                                                 {sessionStorage.getItem("userTypeCodeModel") === "1" && (
                                                                   <td>{seedDemoData.districtName || "N/A"}</td>
                                                                 )}
                                                                 {sessionStorage.getItem("userTypeCodeModel") === "2" && (
                                                                   <td>{seedDemoData.subDistrictName || "N/A"}</td>
                                                                 )}
                                                                 <td>{seedDemoData.totalDemonstration || "0"}</td>
                                                                 <td>{seedDemoData.totalFarmers || "0"}</td>
                                                                 <td>{seedDemoData.inputCount || "0"}</td>
                                                                 <td>{seedDemoData.polygonsCreated || "0"}</td>
                                                                 <td>{seedDemoData.outputCount || "0"}</td>
                                                               </tr>
                                                             ))
                                                           ) : (
                                                             <tr>
                                                               <td colSpan={7} className="text-center">No data available</td>
                                                             </tr>
                                                           )}
                                                         </tbody>
                                                       </table>
                                                     </div>
                                                   </td>
                                                 </tr>
                                               )} */}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={8} className="text-center">
                                  No Asset Count data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* Table  */}
              {/* {pdmcVisible && (
                             <div className="col-lg-12">
                               <div className="card">
                                 <div className="card-body">
                                   <h5 className="card-title">PDMC API Details</h5>
                                   <div className="table-responsive">
                                     <div className="d-flex justify-content-end mb-2">
                                       <button
                                         className="btn btn-sm btn-success"
                                         onClick={exportPdmcToCSV}
                                         style={{ top: "14px", position: "absolute" }}
                                       >
                                         Export PDMC CSV
                                       </button>
                                     </div>
                                     <table className="table table-striped">
                                       <thead>
                                         <tr>
                                           <th>Sr. No.</th>
                                           {sessionStorage.getItem("userTypeCodeModel") ===
                                             "1" && <th>State Name</th>}
                                           {sessionStorage.getItem("userTypeCodeModel") ===
                                             "2" && <th>District Name</th>}
                                           {sessionStorage.getItem("userTypeCodeModel") ===
                                             "3" && <th>Sub District Name</th>}
                                           <th>Total Count</th>
                                           {sessionStorage.getItem("userTypeCodeModel") ===
                                             "1" && <th>Action</th>}
                                         </tr>
                                       </thead>
                                       <tbody>
                                         {latestPdmcCount && latestPdmcCount.length > 0 ? (
                                           (showAllPdmcRows
                                             ? latestPdmcCount
                                             : latestPdmcCount.slice(0, 5)
                                           ).map((pdmc, index) => (
                                             <React.Fragment key={index}>
                                               <tr>
                                                 <td>{index + 1}</td>
                                                 {sessionStorage.getItem(
                                                   "userTypeCodeModel"
                                                 ) === "1" && (
                                                   <td>{pdmc.stateName || "N/A"}</td>
                                                 )}
                                                 {sessionStorage.getItem(
                                                   "userTypeCodeModel"
                                                 ) === "2" && (
                                                   <td>{pdmc.districtName || "N/A"}</td>
                                                 )}
                                                 {sessionStorage.getItem(
                                                   "userTypeCodeModel"
                                                 ) === "3" && (
                                                   <td>{pdmc.subDistrictName || "N/A"}</td>
                                                 )}
                                                 <td>{pdmc.total || "0"}</td>{" "}
                                                 {sessionStorage.getItem(
                                                   "userTypeCodeModel"
                                                 ) === "1" && (
                                                   <td>
                                                     <a
                                                       href="#"
                                                       onClick={(e) => {
                                                         e.preventDefault();
                                                         handlePdmcRowToggle(index, pdmc);
                                                       }}
                                                     >
                                                       <i
                                                         className={`bi ${
                                                           expandedPdmcRowIndex === index
                                                             ? "bi-dash"
                                                             : "bi-plus"
                                                         }`}
                                                       ></i>
                                                     </a>
                                                   </td>
                                                 )}
                                               </tr>
                                               {expandedPdmcRowIndex === index && (
                                                 <tr>
                                                   <td colSpan={9}>
                                                     <div className="table-responsive">
                                                       <table className="table table-hover table-primary">
                                                         <thead>
                                                           <tr>
                                                             <th>Sr. No.</th>
                                                             {sessionStorage.getItem(
                                                               "userTypeCodeModel"
                                                             ) === "1" && <th>District</th>}
                                                             {sessionStorage.getItem(
                                                               "userTypeCodeModel"
                                                             ) === "2" && (
                                                               <th>Sub District</th>
                                                             )}
                                                             <th>Total Count</th>
                                                           </tr>
                                                         </thead>
                                                         <tbody>
                                                           {Array.isArray(
                                                             expandedPdmcRowData
                                                           ) &&
                                                           expandedPdmcRowData.length > 0 ? (
                                                             expandedPdmcRowData.map(
                                                               (pdmcEx, subIndex) => (
                                                                 <tr key={subIndex}>
                                                                   <td>{subIndex + 1}</td>
                                                                   {sessionStorage.getItem(
                                                                     "userTypeCodeModel"
                                                                   ) === "1" && (
                                                                     <td>
                                                                       {pdmcEx.districtName ||
                                                                         "N/A"}
                                                                     </td>
                                                                   )}
                                                                   {sessionStorage.getItem(
                                                                     "userTypeCodeModel"
                                                                   ) === "2" && (
                                                                     <td>
                                                                       {pdmcEx.subDistrictName ||
                                                                         "N/A"}
                                                                     </td>
                                                                   )}
                                                                   <td>
                                                                     {pdmcEx.total || "0"}
                                                                   </td>{" "}
                                                                 </tr>
                                                               )
                                                             )
                                                           ) : (
                                                             <tr>
                                                               <td colSpan={5}>
                                                                 No data available
                                                               </td>
                                                             </tr>
                                                           )}
                                                         </tbody>
                                                       </table>
                                                     </div>
                                                   </td>
                                                 </tr>
                                               )}
                                             </React.Fragment>
                                           ))
                                         ) : (
                                           <tr>
                                             <td colSpan={5} className="text-center">
                                               No PDMC data available
                                             </td>
                                           </tr>
                                         )}
                                       </tbody>
                                       
                                     </table>
                                   </div>
                                   {latestPdmcCount && latestPdmcCount.length > 5 && (
                                     <div className="mt-2">
                                       <button
                                         className="btn btn-link"
                                         onClick={() => setShowAllPdmcRows(!showAllPdmcRows)}
                                       >
                                         {showAllPdmcRows ? "- Show Less" : "+ Show More"}
                                       </button>
                                     </div>
                                   )}
                                 </div>
                               </div>
                             </div>
                           )} */}

              {pdmcVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">PDMC API Details</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportPdmcToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export PDMC CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>Total Count</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>
                            {latestPdmcCount && latestPdmcCount.length > 0 ? (
                              (showAllPdmcRows
                                ? latestPdmcCount
                                : latestPdmcCount.slice(0, 5)
                              ).map((pdmc, index) => (
                                <React.Fragment key={index}>
                                  <tr>
                                    <td>{index + 1}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>{pdmc.stateName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "2" && (
                                      <td>{pdmc.districtName || "N/A"}</td>
                                    )}
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "3" && (
                                      <td>{pdmc.subDistrictName || "N/A"}</td>
                                    )}
                                    <td>{pdmc.total || "0"}</td>
                                    {sessionStorage.getItem(
                                      "userTypeCodeModel"
                                    ) === "1" && (
                                      <td>
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handlePdmcRowToggle(index, pdmc);
                                          }}
                                        >
                                          <i
                                            className={`bi ${
                                              expandedPdmcRowIndex === index
                                                ? "bi-dash"
                                                : "bi-plus"
                                            }`}
                                          ></i>
                                        </a>
                                      </td>
                                    )}
                                  </tr>
                                  {expandedPdmcRowIndex === index && (
                                    <tr>
                                      <td colSpan={9}>
                                        <div className="table-responsive">
                                          <table className="table table-hover table-primary">
                                            <thead>
                                              <tr>
                                                <th>Sr. No.</th>
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "1" && <th>District</th>}
                                                {sessionStorage.getItem(
                                                  "userTypeCodeModel"
                                                ) === "2" && (
                                                  <th>Sub District</th>
                                                )}
                                                <th>Total Count</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {/* ✅ Loading Spinner Add Karo */}
                                              {isLoadingExpandedData ? (
                                                <tr>
                                                  <td
                                                    colSpan={3}
                                                    className="text-center py-4"
                                                  >
                                                    <div className="d-flex justify-content-center align-items-center">
                                                      <div
                                                        className="spinner-border text-primary me-2"
                                                        role="status"
                                                      >
                                                        <span className="visually-hidden">
                                                          Loading...
                                                        </span>
                                                      </div>
                                                      <span>
                                                        Loading data...
                                                      </span>
                                                    </div>
                                                  </td>
                                                </tr>
                                              ) : Array.isArray(
                                                  expandedPdmcRowData
                                                ) &&
                                                expandedPdmcRowData.length >
                                                  0 ? (
                                                expandedPdmcRowData.map(
                                                  (pdmcEx, subIndex) => (
                                                    <tr key={subIndex}>
                                                      <td>{subIndex + 1}</td>
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "1" && (
                                                        <td>
                                                          {pdmcEx.districtName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      {sessionStorage.getItem(
                                                        "userTypeCodeModel"
                                                      ) === "2" && (
                                                        <td>
                                                          {pdmcEx.subDistrictName ||
                                                            "N/A"}
                                                        </td>
                                                      )}
                                                      <td>
                                                        {pdmcEx.total || "0"}
                                                      </td>
                                                    </tr>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={3}
                                                    className="text-center py-3"
                                                  >
                                                    No data available
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className="text-center">
                                  No PDMC data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {latestPdmcCount && latestPdmcCount.length > 5 && (
                        <div className="mt-2">
                          <button
                            className="btn btn-link"
                            onClick={() => setShowAllPdmcRows(!showAllPdmcRows)}
                          >
                            {showAllPdmcRows ? " - Show Less" : " + Show More"}
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {stateAPISurveyVisible && (
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title">State API Survey Count</h5>
                      <div className="table-responsive">
                        <div className="d-flex justify-content-end mb-2">
                          <button
                            className="btn btn-sm btn-success"
                            onClick={exportStateAPISurveyToCSV}
                            style={{ top: "14px", position: "absolute" }}
                          >
                            Export State API Survey CSV
                          </button>
                        </div>
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Sr. No.</th>
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "1" && <th>State Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "2" && <th>District Name</th>}
                              {sessionStorage.getItem("userTypeCodeModel") ===
                                "3" && <th>Sub District Name</th>}
                              <th>Total Survey</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stateAPISurveyRows &&
                            stateAPISurveyRows.length > 0 ? (
                              stateAPISurveyRows.map((row, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "1" && <td>{row.stateName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "2" && <td>{row.districtName}</td>}
                                  {sessionStorage.getItem(
                                    "userTypeCodeModel"
                                  ) === "3" && <td>{row.subDistrictName}</td>}
                                  <td>{row.totalSurvey}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No data available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            {schemeCode === "14" && (
              <div className="col-md-12">
                <button
                  className="showagency"
                  onClick={() => setShowAgencyCounts(!showAgencyCounts)}
                >
                  {showAgencyCounts
                    ? "Hide Agency Counts"
                    : "Show Agency Counts"}
                </button>

                {showAgencyCounts && (
                  <div className="row">
                    <AgencyCard
                      title="National Mission on Edible Oils - Created Polygon"
                      count={nmeoopCount}
                      icon={faOilCan}
                      exportData={nmeoopData}
                      fileName="NMEO_Polygon_Data"
                    />
                    <AgencyCard
                      title="KE Cultivation"
                      count={kEcultivationCount}
                      icon={faSeedling}
                      exportData={kEcultivationData}
                      fileName="KE_Cultivation_Data"
                    />
                    <AgencyCard
                      title="NMEO 3F Prospective"
                      count={nMEO3FCount}
                      icon={faBinoculars}
                      exportData={nmeo3fData}
                      fileName="NMEO_3F_Prospective"
                    />
                    <AgencyCard
                      title="Patanjali"
                      count={patanjaliCount}
                      icon={faLeaf}
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </section>

        {LoaderFarmer && (
          <div className="overlay">
            <div className="overlay__inner">
              <div className="overlay__content">
                <span className="spinner"></span>
              </div>
            </div>
          </div>
        )}
      </main>
      <AdminFooterNew />
    </>
  );
};

export default Dashboard;
